var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    {
      staticClass: "pa-0",
      class: { "pb-2 px-0 pt-0": _vm.stackedView, "pa-0": !_vm.stackedView },
      attrs: { fluid: "" },
    },
    [
      _c(
        "v-row",
        { staticClass: "justify-space-between" },
        [
          _c(
            "v-col",
            {
              class: {
                "px-4 py-0": _vm.stackedView,
                "px-0 pl-3 pt-2 pb-1 pb-sm-3": !_vm.stackedView,
                "pr-4": _vm.$vuetify.breakpoint.mdAndDown,
              },
              attrs: {
                cols: "12",
                sm: "12",
                md: _vm.stackedView ? 12 : 4,
                order: _vm.stackedView ? 2 : 1,
              },
            },
            [
              (_vm.currentUser.clientType === "Media" ||
                _vm.currentUser.clientType === "Driblab") &&
              !_vm.stackedView
                ? _c("MediaModeForm", {
                    attrs: {
                      fields: _vm.mediaModeFields,
                      mediaMode: _vm.mediaMode,
                      mediaModeData: _vm.mediaModeData,
                      mediaModeFlags: _vm.mediaModeFlags,
                      selectorMode: "",
                    },
                    on: {
                      mediaModeChange: function ($event) {
                        return _vm.onMediaModeChange($event)
                      },
                      mediaModeDataChange: function ($event) {
                        return _vm.onMediaModeDataChange($event)
                      },
                      mediaModeFlagsChange: function ($event) {
                        _vm.mediaModeFlags = $event
                      },
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _c(
                "v-card",
                {
                  staticClass: "mx-auto pa-1",
                  attrs: { elevation: "0", outlined: "" },
                },
                [
                  _c(
                    "v-card-actions",
                    { staticClass: "d-flex flex-column" },
                    [
                      _c(
                        "v-row",
                        {
                          staticClass: "w-100",
                          attrs: { id: "player-season-selector" },
                        },
                        [
                          _c(
                            "v-col",
                            { staticClass: "pa-0 py-2", attrs: { cols: "12" } },
                            [
                              _c(
                                "v-card-title",
                                {
                                  staticClass: "pa-0 mb-0 header-font",
                                  staticStyle: { "font-size": "22px" },
                                },
                                [_vm._v(_vm._s(_vm.$t("general.filters")))]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.playerSeasonsPlayed &&
                          _vm.playerSeasonsPlayed.length >= 8
                            ? _c(
                                "v-col",
                                {
                                  staticClass: "px-0 pt-1",
                                  attrs: { cols: "12", sm: "12" },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "mr-5 pt-0 mt-0 primary--text font-weight-bold body-1",
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(_vm.$t("app.seasonStats")) +
                                          "\n                "
                                      ),
                                      _vm.loading
                                        ? _c("v-skeleton-loader", {
                                            staticClass: "mt-2",
                                            attrs: { type: "text" },
                                          })
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _vm.showSeasonsAsCheckbox && !_vm.loading
                                    ? _c("v-autocomplete", {
                                        staticClass: "w-100",
                                        attrs: {
                                          items: _vm.playerSeasonDataFiltered,
                                          clearable: "",
                                          multiple: "",
                                          "hide-details": "",
                                          dense: "",
                                          "item-value": "compoundId",
                                          "item-text": "compoundText",
                                          "menu-props": {
                                            bottom: true,
                                            offsetY: true,
                                            offsetOverflow: false,
                                          },
                                        },
                                        on: {
                                          change: function ($event) {
                                            return _vm.onAutoCompleteSeasonChange(
                                              $event
                                            )
                                          },
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "selection",
                                              fn: function ({ item, index }) {
                                                return [
                                                  index <= 2
                                                    ? _c(
                                                        "v-chip",
                                                        {
                                                          staticClass:
                                                            "body-2 mb-1 black--text",
                                                          attrs: {
                                                            small: "",
                                                            color:
                                                              "lightSecondary lighten-2",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "object",
                                                            {
                                                              staticClass:
                                                                "mr-2",
                                                              attrs: {
                                                                data: `https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/leagues/${item.leagueId}.png`,
                                                                type: "image/png",
                                                                height: "20",
                                                              },
                                                            },
                                                            [
                                                              _c("img", {
                                                                attrs: {
                                                                  src: `https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/0.png`,
                                                                  height: "20",
                                                                },
                                                              }),
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "font-weight-bold",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  item.seasonName
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "mx-1",
                                                            },
                                                            [_vm._v("@")]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "font-weight-medium",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  item.teamName
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  index === 3
                                                    ? _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "primary--text body-2 subheader-font",
                                                        },
                                                        [
                                                          _vm._v(
                                                            "(+" +
                                                              _vm._s(
                                                                _vm
                                                                  .seasonDataSelectedCheckBoxModel
                                                                  .length - 3
                                                              ) +
                                                              " " +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "finishingMap.more"
                                                                )
                                                              ) +
                                                              ")"
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                ]
                                              },
                                            },
                                            {
                                              key: "item",
                                              fn: function ({ item }) {
                                                return [
                                                  _c(
                                                    "v-card-text",
                                                    {
                                                      staticClass:
                                                        "px-0 py-1 primary--text body-2 font-weight-medium d-flex flex-column align-start justify-center",
                                                    },
                                                    [
                                                      _c("div", [
                                                        _c(
                                                          "object",
                                                          {
                                                            staticClass: "mr-2",
                                                            attrs: {
                                                              data: `https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/leagues/${item.leagueId}.png`,
                                                              type: "image/png",
                                                              height: "18",
                                                            },
                                                          },
                                                          [
                                                            _c("img", {
                                                              attrs: {
                                                                src: `https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/0.png`,
                                                                height: "15",
                                                              },
                                                            }),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              item.seasonName
                                                            )
                                                          ),
                                                        ]),
                                                      ]),
                                                      _vm._v(" "),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "body-2 subheader-font",
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                      " +
                                                              _vm._s(
                                                                item.teamName
                                                              ) +
                                                              " \n                      "
                                                          ),
                                                          item.minutesPlayedPD &&
                                                          _vm.templateActive &&
                                                          (_vm.templateActive
                                                            .cPD ||
                                                            _vm.templateActive
                                                              .cA)
                                                            ? _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "ms-1",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                        " +
                                                                      _vm._s(
                                                                        `(${
                                                                          item.minutesPlayedPD
                                                                        } ${_vm.$t(
                                                                          "table.history.minutes"
                                                                        )})`
                                                                      ) +
                                                                      "\n                      "
                                                                  ),
                                                                ]
                                                              )
                                                            : item.minutesPlayed
                                                            ? _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "ms-1",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                        " +
                                                                      _vm._s(
                                                                        `(${
                                                                          item.minutesPlayed
                                                                        } ${_vm.$t(
                                                                          "table.history.minutes"
                                                                        )})`
                                                                      ) +
                                                                      "\n                      "
                                                                  ),
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          4164546050
                                        ),
                                        model: {
                                          value:
                                            _vm.seasonDataSelectedCheckBoxModel,
                                          callback: function ($$v) {
                                            _vm.seasonDataSelectedCheckBoxModel =
                                              $$v
                                          },
                                          expression:
                                            "seasonDataSelectedCheckBoxModel",
                                        },
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  !_vm.showSeasonsAsCheckbox
                                    ? _c("v-autocomplete", {
                                        attrs: {
                                          clearable: "",
                                          items: _vm.playerSeasonDataFiltered,
                                          "hide-details": "",
                                          dense: "",
                                          "item-value": "compoundId",
                                          "item-text": "compoundText",
                                        },
                                        on: {
                                          change: function ($event) {
                                            return _vm.onAutoCompleteSeasonChange(
                                              $event
                                            )
                                          },
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "selection",
                                              fn: function ({ item }) {
                                                return [
                                                  _c(
                                                    "v-chip",
                                                    {
                                                      staticClass:
                                                        "body-2 mb-1 black--text",
                                                      attrs: {
                                                        small: "",
                                                        color:
                                                          "lightSecondary lighten-2",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "object",
                                                        {
                                                          staticClass: "mr-2",
                                                          attrs: {
                                                            data: `https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/leagues/${item.leagueId}.png`,
                                                            type: "image/png",
                                                            height: "20",
                                                          },
                                                        },
                                                        [
                                                          _c("img", {
                                                            attrs: {
                                                              src: `https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/0.png`,
                                                              height: "20",
                                                            },
                                                          }),
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "font-weight-bold",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              item.seasonName
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "span",
                                                        { staticClass: "mx-1" },
                                                        [_vm._v("@")]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "font-weight-medium",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              item.teamName
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              },
                                            },
                                            {
                                              key: "item",
                                              fn: function ({ item }) {
                                                return [
                                                  _c(
                                                    "v-card-text",
                                                    {
                                                      staticClass:
                                                        "px-0 py-1 primary--text body-2 font-weight-medium d-flex flex-column align-start justify-center",
                                                    },
                                                    [
                                                      _c("div", [
                                                        _c(
                                                          "object",
                                                          {
                                                            staticClass: "mr-2",
                                                            attrs: {
                                                              data: `https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/leagues/${item.leagueId}.png`,
                                                              type: "image/png",
                                                              height: "18",
                                                            },
                                                          },
                                                          [
                                                            _c("img", {
                                                              attrs: {
                                                                src: `https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/0.png`,
                                                                height: "15",
                                                              },
                                                            }),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              item.seasonName
                                                            )
                                                          ),
                                                        ]),
                                                      ]),
                                                      _vm._v(" "),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "body-2 subheader-font",
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                      " +
                                                              _vm._s(
                                                                item.teamName
                                                              ) +
                                                              " \n                      "
                                                          ),
                                                          item.minutesPlayedPD &&
                                                          _vm.templateActive &&
                                                          (_vm.templateActive
                                                            .cPD ||
                                                            _vm.templateActive
                                                              .cA)
                                                            ? _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "ms-1",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                        " +
                                                                      _vm._s(
                                                                        `(${
                                                                          item.minutesPlayedPD
                                                                        } ${_vm.$t(
                                                                          "table.history.minutes"
                                                                        )})`
                                                                      ) +
                                                                      "\n                      "
                                                                  ),
                                                                ]
                                                              )
                                                            : item.minutesPlayed
                                                            ? _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "ms-1",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                        " +
                                                                      _vm._s(
                                                                        `(${
                                                                          item.minutesPlayed
                                                                        } ${_vm.$t(
                                                                          "table.history.minutes"
                                                                        )})`
                                                                      ) +
                                                                      "\n                      "
                                                                  ),
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          3817534024
                                        ),
                                        model: {
                                          value:
                                            _vm.seasonDataSelectedRadiosModel,
                                          callback: function ($$v) {
                                            _vm.seasonDataSelectedRadiosModel =
                                              $$v
                                          },
                                          expression:
                                            "seasonDataSelectedRadiosModel",
                                        },
                                      })
                                    : _vm._e(),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.playerSeasonsPlayed &&
                          _vm.playerSeasonsPlayed.length < 8
                            ? _c(
                                "v-col",
                                {
                                  staticClass: "d-flex py-0 align-start pr-0",
                                  attrs: { cols: "12" },
                                },
                                [
                                  _c(
                                    "v-row",
                                    [
                                      _vm._l(
                                        _vm.playerSeasonDataCurrentYear,
                                        function (seasonData, index) {
                                          return _vm.showSeasonsAsCheckbox
                                            ? _c(
                                                "v-col",
                                                {
                                                  key: index,
                                                  staticClass:
                                                    "d-flex py-0 pr-1",
                                                  attrs: {
                                                    cols: "12",
                                                    sm: "12",
                                                  },
                                                },
                                                [
                                                  _c("v-checkbox", {
                                                    key: index,
                                                    staticClass:
                                                      "px-2 mt-0 py-1",
                                                    attrs: {
                                                      value: `${seasonData.seasonId}-${seasonData.teamId}`,
                                                      color: "secondary",
                                                      "hide-details": "",
                                                      disabled:
                                                        seasonData.disabled,
                                                    },
                                                    on: {
                                                      change: function (
                                                        $event
                                                      ) {
                                                        return _vm.onSeasonChange(
                                                          seasonData
                                                        )
                                                      },
                                                    },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "label",
                                                          fn: function () {
                                                            return [
                                                              _c(
                                                                "v-card-text",
                                                                {
                                                                  staticClass:
                                                                    "pa-0 primary--text body-1 font-weight-medium d-flex flex-column align-start justify-center",
                                                                },
                                                                [
                                                                  _c("div", [
                                                                    _c(
                                                                      "object",
                                                                      {
                                                                        staticClass:
                                                                          "mr-2",
                                                                        attrs: {
                                                                          data: `https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/leagues/${seasonData.leagueId}.png`,
                                                                          type: "image/png",
                                                                          height:
                                                                            "18",
                                                                        },
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "img",
                                                                          {
                                                                            attrs:
                                                                              {
                                                                                src: `https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/0.png`,
                                                                                height:
                                                                                  "15",
                                                                              },
                                                                          }
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _vm._v(" "),
                                                                    _c("span", [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          seasonData.seasonName
                                                                        )
                                                                      ),
                                                                    ]),
                                                                  ]),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "body-2 subheader-font",
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "\n                          " +
                                                                          _vm._s(
                                                                            seasonData.teamName
                                                                          ) +
                                                                          " \n                          "
                                                                      ),
                                                                      seasonData.minutesPlayed
                                                                        ? _c(
                                                                            "span",
                                                                            {
                                                                              staticClass:
                                                                                "ms-1",
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                _vm._s(
                                                                                  `(${
                                                                                    seasonData.minutesPlayed
                                                                                  } ${_vm.$t(
                                                                                    "table.history.minutes"
                                                                                  )})`
                                                                                )
                                                                              ),
                                                                            ]
                                                                          )
                                                                        : _vm._e(),
                                                                    ]
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          },
                                                          proxy: true,
                                                        },
                                                      ],
                                                      null,
                                                      true
                                                    ),
                                                    model: {
                                                      value:
                                                        _vm.seasonDataSelectedCheckBoxModel,
                                                      callback: function ($$v) {
                                                        _vm.seasonDataSelectedCheckBoxModel =
                                                          $$v
                                                      },
                                                      expression:
                                                        "seasonDataSelectedCheckBoxModel",
                                                    },
                                                  }),
                                                ],
                                                1
                                              )
                                            : _vm._e()
                                        }
                                      ),
                                      _vm._v(" "),
                                      _vm._l(
                                        _vm.playerSeasonDataCurrentYear,
                                        function (seasonData, index) {
                                          return !_vm.showSeasonsAsCheckbox
                                            ? _c(
                                                "v-col",
                                                {
                                                  key: index,
                                                  staticClass:
                                                    "d-flex py-0 pr-1",
                                                  attrs: {
                                                    cols: "12",
                                                    sm: "12",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "v-radio-group",
                                                    {
                                                      staticClass:
                                                        "mt-0 d-flex flex-column",
                                                      attrs: {
                                                        value: `${seasonData.seasonId}-${seasonData.teamId}`,
                                                        row: "",
                                                        dense: "",
                                                        "hide-details": "",
                                                      },
                                                      on: {
                                                        change: function (
                                                          $event
                                                        ) {
                                                          return _vm.onSeasonChange(
                                                            seasonData
                                                          )
                                                        },
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.seasonDataSelectedRadiosModel,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.seasonDataSelectedRadiosModel =
                                                            $$v
                                                        },
                                                        expression:
                                                          "seasonDataSelectedRadiosModel",
                                                      },
                                                    },
                                                    [
                                                      _c("v-radio", {
                                                        key: index,
                                                        staticClass:
                                                          "px-2 mt-0",
                                                        attrs: {
                                                          value: `${seasonData.seasonId}-${seasonData.teamId}`,
                                                          color: "secondary",
                                                          disabled:
                                                            seasonData.disabled,
                                                        },
                                                        scopedSlots: _vm._u(
                                                          [
                                                            {
                                                              key: "label",
                                                              fn: function () {
                                                                return [
                                                                  _c(
                                                                    "v-card-text",
                                                                    {
                                                                      staticClass:
                                                                        "pa-0 primary--text body-2 font-weight-medium d-flex flex-column align-start justify-center",
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "div",
                                                                        [
                                                                          _c(
                                                                            "object",
                                                                            {
                                                                              staticClass:
                                                                                "mr-2",
                                                                              attrs:
                                                                                {
                                                                                  data: `https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/leagues/${seasonData.leagueId}.png`,
                                                                                  type: "image/png",
                                                                                  height:
                                                                                    "18",
                                                                                },
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "img",
                                                                                {
                                                                                  attrs:
                                                                                    {
                                                                                      src: `https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/0.png`,
                                                                                      height:
                                                                                        "15",
                                                                                    },
                                                                                }
                                                                              ),
                                                                            ]
                                                                          ),
                                                                          _vm._v(
                                                                            " "
                                                                          ),
                                                                          _c(
                                                                            "span",
                                                                            [
                                                                              _vm._v(
                                                                                _vm._s(
                                                                                  seasonData.seasonName
                                                                                )
                                                                              ),
                                                                            ]
                                                                          ),
                                                                        ]
                                                                      ),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _c(
                                                                        "span",
                                                                        {
                                                                          staticClass:
                                                                            "body-2 subheader-font",
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "\n                            " +
                                                                              _vm._s(
                                                                                seasonData.teamName
                                                                              ) +
                                                                              " \n                            "
                                                                          ),
                                                                          seasonData.minutesPlayed
                                                                            ? _c(
                                                                                "span",
                                                                                {
                                                                                  staticClass:
                                                                                    "ms-1",
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    _vm._s(
                                                                                      `(${
                                                                                        seasonData.minutesPlayed
                                                                                      } ${_vm.$t(
                                                                                        "table.history.minutes"
                                                                                      )})`
                                                                                    )
                                                                                  ),
                                                                                ]
                                                                              )
                                                                            : _vm._e(),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              },
                                                              proxy: true,
                                                            },
                                                          ],
                                                          null,
                                                          true
                                                        ),
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              )
                                            : _vm._e()
                                        }
                                      ),
                                    ],
                                    2
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.playerSeasonsPlayed &&
                          _vm.playerSeasonsPlayed.length < 8
                            ? _c(
                                "v-col",
                                {
                                  staticClass: "d-flex py-0 align-start",
                                  attrs: { cols: "12" },
                                },
                                [
                                  _vm.playerSeasonDataLastYear
                                    ? _c(
                                        "v-row",
                                        [
                                          _vm._l(
                                            _vm.playerSeasonDataLastYear,
                                            function (seasonData, index) {
                                              return _vm.showSeasonsAsCheckbox
                                                ? _c(
                                                    "v-col",
                                                    {
                                                      key: index,
                                                      staticClass:
                                                        "d-flex py-0 pr-1",
                                                      attrs: {
                                                        cols: "12",
                                                        sm: "12",
                                                      },
                                                    },
                                                    [
                                                      _c("v-checkbox", {
                                                        key: index,
                                                        staticClass:
                                                          "px-2 mt-0 py-1",
                                                        attrs: {
                                                          value: `${seasonData.seasonId}-${seasonData.teamId}`,
                                                          "hide-details": "",
                                                          color: "secondary",
                                                          disabled:
                                                            seasonData.disabled,
                                                        },
                                                        on: {
                                                          change: function (
                                                            $event
                                                          ) {
                                                            return _vm.onSeasonChange(
                                                              seasonData
                                                            )
                                                          },
                                                        },
                                                        scopedSlots: _vm._u(
                                                          [
                                                            {
                                                              key: "label",
                                                              fn: function () {
                                                                return [
                                                                  _c(
                                                                    "v-card-text",
                                                                    {
                                                                      staticClass:
                                                                        "pa-0 primary--text body-1 font-weight-medium d-flex flex-column align-start justify-center",
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "div",
                                                                        [
                                                                          _c(
                                                                            "object",
                                                                            {
                                                                              staticClass:
                                                                                "mr-2",
                                                                              attrs:
                                                                                {
                                                                                  data: `https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/leagues/${seasonData.leagueId}.png`,
                                                                                  type: "image/png",
                                                                                  height:
                                                                                    "18",
                                                                                },
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "img",
                                                                                {
                                                                                  attrs:
                                                                                    {
                                                                                      src: `https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/0.png`,
                                                                                      height:
                                                                                        "15",
                                                                                    },
                                                                                }
                                                                              ),
                                                                            ]
                                                                          ),
                                                                          _vm._v(
                                                                            " "
                                                                          ),
                                                                          _c(
                                                                            "span",
                                                                            [
                                                                              _vm._v(
                                                                                _vm._s(
                                                                                  seasonData.seasonName
                                                                                )
                                                                              ),
                                                                            ]
                                                                          ),
                                                                        ]
                                                                      ),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _c(
                                                                        "span",
                                                                        {
                                                                          staticClass:
                                                                            "body-2 subheader-font",
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "\n                          " +
                                                                              _vm._s(
                                                                                seasonData.teamName
                                                                              ) +
                                                                              " \n                          "
                                                                          ),
                                                                          seasonData.minutesPlayed
                                                                            ? _c(
                                                                                "span",
                                                                                {
                                                                                  staticClass:
                                                                                    "ms-1",
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    _vm._s(
                                                                                      `(${
                                                                                        seasonData.minutesPlayed
                                                                                      } ${_vm.$t(
                                                                                        "table.history.minutes"
                                                                                      )})`
                                                                                    )
                                                                                  ),
                                                                                ]
                                                                              )
                                                                            : _vm._e(),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              },
                                                              proxy: true,
                                                            },
                                                          ],
                                                          null,
                                                          true
                                                        ),
                                                        model: {
                                                          value:
                                                            _vm.seasonDataSelectedCheckBoxModel,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.seasonDataSelectedCheckBoxModel =
                                                              $$v
                                                          },
                                                          expression:
                                                            "seasonDataSelectedCheckBoxModel",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  )
                                                : _vm._e()
                                            }
                                          ),
                                          _vm._v(" "),
                                          _vm._l(
                                            _vm.playerSeasonDataLastYear,
                                            function (seasonData, index) {
                                              return !_vm.showSeasonsAsCheckbox
                                                ? _c(
                                                    "v-col",
                                                    {
                                                      key: index,
                                                      staticClass:
                                                        "d-flex py-0 pr-1",
                                                      attrs: {
                                                        cols: "12",
                                                        sm: "12",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "v-radio-group",
                                                        {
                                                          staticClass:
                                                            "mt-0 py-0 d-flex flex-column",
                                                          attrs: {
                                                            value: `${seasonData.seasonId}-${seasonData.teamId}`,
                                                            row: "",
                                                            dense: "",
                                                            "hide-details": "",
                                                          },
                                                          on: {
                                                            change: function (
                                                              $event
                                                            ) {
                                                              return _vm.onSeasonChange(
                                                                seasonData
                                                              )
                                                            },
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.seasonDataSelectedRadiosModel,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.seasonDataSelectedRadiosModel =
                                                                $$v
                                                            },
                                                            expression:
                                                              "seasonDataSelectedRadiosModel",
                                                          },
                                                        },
                                                        [
                                                          _c("v-radio", {
                                                            key: index,
                                                            staticClass:
                                                              "px-2 mt-0 py-1",
                                                            attrs: {
                                                              value: `${seasonData.seasonId}-${seasonData.teamId}`,
                                                              color:
                                                                "secondary",
                                                              disabled:
                                                                seasonData.disabled,
                                                            },
                                                            scopedSlots: _vm._u(
                                                              [
                                                                {
                                                                  key: "label",
                                                                  fn: function () {
                                                                    return [
                                                                      _c(
                                                                        "v-card-text",
                                                                        {
                                                                          staticClass:
                                                                            "pa-0 primary--text body-2 font-weight-medium d-flex flex-column align-start justify-center",
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "div",
                                                                            [
                                                                              _c(
                                                                                "object",
                                                                                {
                                                                                  staticClass:
                                                                                    "mr-2",
                                                                                  attrs:
                                                                                    {
                                                                                      data: `https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/leagues/${seasonData.leagueId}.png`,
                                                                                      type: "image/png",
                                                                                      height:
                                                                                        "18",
                                                                                    },
                                                                                },
                                                                                [
                                                                                  _c(
                                                                                    "img",
                                                                                    {
                                                                                      attrs:
                                                                                        {
                                                                                          src: `https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/0.png`,
                                                                                          height:
                                                                                            "15",
                                                                                        },
                                                                                    }
                                                                                  ),
                                                                                ]
                                                                              ),
                                                                              _vm._v(
                                                                                " "
                                                                              ),
                                                                              _c(
                                                                                "span",
                                                                                [
                                                                                  _vm._v(
                                                                                    _vm._s(
                                                                                      seasonData.seasonName
                                                                                    )
                                                                                  ),
                                                                                ]
                                                                              ),
                                                                            ]
                                                                          ),
                                                                          _vm._v(
                                                                            " "
                                                                          ),
                                                                          _c(
                                                                            "span",
                                                                            {
                                                                              staticClass:
                                                                                "body-2 subheader-font",
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                "\n                            " +
                                                                                  _vm._s(
                                                                                    seasonData.teamName
                                                                                  ) +
                                                                                  " \n                            "
                                                                              ),
                                                                              seasonData.minutesPlayed
                                                                                ? _c(
                                                                                    "span",
                                                                                    {
                                                                                      staticClass:
                                                                                        "ms-1",
                                                                                    },
                                                                                    [
                                                                                      _vm._v(
                                                                                        _vm._s(
                                                                                          `(${
                                                                                            seasonData.minutesPlayed
                                                                                          } ${_vm.$t(
                                                                                            "table.history.minutes"
                                                                                          )})`
                                                                                        )
                                                                                      ),
                                                                                    ]
                                                                                  )
                                                                                : _vm._e(),
                                                                            ]
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  },
                                                                  proxy: true,
                                                                },
                                                              ],
                                                              null,
                                                              true
                                                            ),
                                                          }),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  )
                                                : _vm._e()
                                            }
                                          ),
                                        ],
                                        2
                                      )
                                    : _vm._e(),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-row",
                        { staticClass: "w-100" },
                        [
                          _c(
                            "v-col",
                            {
                              staticClass: "pt-0 pb-1 px-0",
                              attrs: {
                                cols: "12",
                                sm: "12",
                                id: "filter-radar-games",
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "mr-5 pt-2 primary--text font-weight-bold body-1",
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(_vm.$t("general.games")) +
                                      "\n                "
                                  ),
                                  _vm.loading
                                    ? _c("v-skeleton-loader", {
                                        staticClass: "mt-2",
                                        attrs: { type: "paragraph,text" },
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.seasonsWithout60MinsGames && !_vm.loading
                                    ? _c(
                                        "v-tooltip",
                                        {
                                          attrs: {
                                            top: "",
                                            color: "lightSecondary lighten-4",
                                            "max-width": "300",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "activator",
                                                fn: function ({ on, attrs }) {
                                                  return [
                                                    _c(
                                                      "v-icon",
                                                      _vm._g(
                                                        _vm._b(
                                                          {
                                                            staticClass: "ms-1",
                                                            attrs: {
                                                              "x-small": "",
                                                              color:
                                                                "secondary",
                                                            },
                                                          },
                                                          "v-icon",
                                                          attrs,
                                                          false
                                                        ),
                                                        on
                                                      ),
                                                      [_vm._v("info")]
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            false,
                                            2188377934
                                          ),
                                        },
                                        [
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              staticClass: "black--text body-1",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "disabledTooltips.seasonsWithout60MinsGames"
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              !_vm.loading
                                ? _c(
                                    "v-radio-group",
                                    {
                                      staticClass: "pl-2 mt-0",
                                      attrs: {
                                        row: "",
                                        dense: "",
                                        "hide-details": "",
                                        disabled: _vm.seasonsWithout60MinsGames,
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.onRadarGamesChange()
                                        },
                                      },
                                      model: {
                                        value: _vm.allGamesModel,
                                        callback: function ($$v) {
                                          _vm.allGamesModel = $$v
                                        },
                                        expression: "allGamesModel",
                                      },
                                    },
                                    [
                                      _c("v-radio", {
                                        attrs: {
                                          value: true,
                                          color: "secondary",
                                          label: _vm.$t("general.all"),
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "label",
                                              fn: function () {
                                                return [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "body-1 primary--text font-weight-medium",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                      " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "general.all"
                                                            )
                                                          ) +
                                                          "\n                    "
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              },
                                              proxy: true,
                                            },
                                          ],
                                          null,
                                          false,
                                          2420071248
                                        ),
                                      }),
                                      _vm._v(" "),
                                      _c("v-radio", {
                                        attrs: {
                                          value: false,
                                          color: "secondary",
                                          label: "+60 mins.",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "label",
                                              fn: function () {
                                                return [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "body-1 primary--text font-weight-medium",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                      +60 mins.\n                    "
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              },
                                              proxy: true,
                                            },
                                          ],
                                          null,
                                          false,
                                          1965873967
                                        ),
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            {
                              staticClass: "pt-0 pb-1",
                              attrs: {
                                cols: "12",
                                sm: "12",
                                id: "player-radar-selector",
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "mr-5 pt-2 primary--text font-weight-bold body-1",
                                },
                                [
                                  _vm._v(
                                    "\n                Radar " +
                                      _vm._s(
                                        _vm.$t("playerRecruitment.template")
                                      ) +
                                      "\n                "
                                  ),
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass:
                                        "elevation-0 monospace-font white--text px-2",
                                      attrs: {
                                        small: "",
                                        rounded: "",
                                        color: "secondary",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.onNewTemplateClick()
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "v-icon",
                                        {
                                          attrs: { color: "white", small: "" },
                                        },
                                        [_vm._v("add")]
                                      ),
                                      _vm._v(
                                        _vm._s(_vm.$t("general.new")) +
                                          "\n                "
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _vm.loading
                                    ? _c("v-skeleton-loader", {
                                        staticClass: "mt-2",
                                        attrs: { type: "paragraph,text" },
                                      })
                                    : _vm._e(),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              !_vm.loading
                                ? _c(
                                    "v-radio-group",
                                    {
                                      staticClass:
                                        "pl-2 mt-0 d-flex flex-column",
                                      attrs: { dense: "", "hide-details": "" },
                                      on: {
                                        change: function ($event) {
                                          return _vm.onTemplateChange()
                                        },
                                      },
                                      model: {
                                        value: _vm.templateActiveId,
                                        callback: function ($$v) {
                                          _vm.templateActiveId = $$v
                                        },
                                        expression: "templateActiveId",
                                      },
                                    },
                                    _vm._l(
                                      _vm.groupedTemplates,
                                      function (group, groupKey) {
                                        return _c(
                                          "div",
                                          {
                                            key: groupKey,
                                            staticClass: "mb-4",
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "mb-2 primary--text font-weight-bold subheader-font body-1",
                                              },
                                              [
                                                _c(
                                                  "v-icon",
                                                  {
                                                    staticClass: "me-1",
                                                    style: `font-size: ${
                                                      _vm.getRadarTemplateSubtitle(
                                                        groupKey
                                                      ).size
                                                    }`,
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                      " +
                                                        _vm._s(
                                                          _vm.getRadarTemplateSubtitle(
                                                            groupKey
                                                          ).icon
                                                        ) +
                                                        "\n                    "
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(
                                                      _vm.getRadarTemplateSubtitle(
                                                        groupKey
                                                      ).label
                                                    ) +
                                                    "\n                  "
                                                ),
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-row",
                                              {
                                                staticClass: "d-flex flex-row",
                                                attrs: {
                                                  dense: "",
                                                  "no-gutters": "",
                                                  wrap: "",
                                                },
                                              },
                                              _vm._l(
                                                group,
                                                function (template) {
                                                  return _c(
                                                    "v-col",
                                                    {
                                                      key: template.radarId,
                                                      attrs: { cols: "auto" },
                                                    },
                                                    [
                                                      _c("v-radio", {
                                                        staticClass:
                                                          "me-2 custom-radio",
                                                        style:
                                                          _vm.getRadioStyle(
                                                            template
                                                          ),
                                                        attrs: {
                                                          value:
                                                            template.radarId,
                                                          color: "secondary",
                                                          disabled:
                                                            (_vm.xyTemplateDisabled &&
                                                              template.cXY) ||
                                                            (_vm.physicalRadarDisabled &&
                                                              template.cPD) ||
                                                            (_vm.arrigoRadarDisabled &&
                                                              template.cA),
                                                        },
                                                        scopedSlots: _vm._u(
                                                          [
                                                            {
                                                              key: "label",
                                                              fn: function () {
                                                                return [
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "body-1 primary--text font-weight-medium",
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "\n                            " +
                                                                          _vm._s(
                                                                            template.radarName
                                                                          ) +
                                                                          "\n                          "
                                                                      ),
                                                                    ]
                                                                  ),
                                                                  _vm._v(" "),
                                                                  _vm.hasCustomRadars &&
                                                                  template.clientId ===
                                                                    0
                                                                    ? _c(
                                                                        "span",
                                                                        {
                                                                          staticClass:
                                                                            "ml-1 body-2",
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "(Driblab)"
                                                                          ),
                                                                        ]
                                                                      )
                                                                    : _vm._e(),
                                                                ]
                                                              },
                                                              proxy: true,
                                                            },
                                                          ],
                                                          null,
                                                          true
                                                        ),
                                                      }),
                                                    ],
                                                    1
                                                  )
                                                }
                                              ),
                                              1
                                            ),
                                          ],
                                          1
                                        )
                                      }
                                    ),
                                    0
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-col",
                            {
                              staticClass: "pt-0 pb-1",
                              attrs: {
                                cols: "12",
                                sm: "12",
                                id: "player-position-selector",
                              },
                            },
                            [
                              _c("div", { staticClass: "d-flex flex-column" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "mr-5 pt-2 primary--text font-weight-bold body-1",
                                  },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(
                                          _vm.$t(
                                            "playerRecruitment.positionsPlayed"
                                          )
                                        ) +
                                        "\n                  "
                                    ),
                                    _vm.loading
                                      ? _c("v-skeleton-loader", {
                                          staticClass: "mt-2",
                                          attrs: { type: "text" },
                                        })
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                !_vm.loading
                                  ? _c(
                                      "div",
                                      { staticClass: "pl-2 d-flex flex-wrap" },
                                      _vm._l(
                                        _vm.shortPositionsPlayed,
                                        function (shortPosition, index) {
                                          return _c("v-checkbox", {
                                            key: index,
                                            staticClass:
                                              "mr-2 mt-0 py-1 body-2",
                                            attrs: {
                                              value: shortPosition.position,
                                              dense: "",
                                              "hide-details": "",
                                              color: "secondary",
                                            },
                                            on: {
                                              change: function ($event) {
                                                return _vm.onShortPositionChange(
                                                  shortPosition.position
                                                )
                                              },
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "label",
                                                  fn: function () {
                                                    return [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "body-1 primary--text font-weight-medium",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              `${_vm.getPositionCode(
                                                                shortPosition.fieldPositionId
                                                              )} (${
                                                                shortPosition.minutesPlayed
                                                              } min.)`
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  },
                                                  proxy: true,
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                            model: {
                                              value:
                                                _vm.shortPositionsPlayedModel,
                                              callback: function ($$v) {
                                                _vm.shortPositionsPlayedModel =
                                                  $$v
                                              },
                                              expression:
                                                "shortPositionsPlayedModel",
                                            },
                                          })
                                        }
                                      ),
                                      1
                                    )
                                  : _vm._e(),
                              ]),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-col",
                            {
                              staticClass: "pt-0 pb-1",
                              attrs: {
                                cols: "12",
                                sm: "12",
                                id: "player-minmax-selector",
                              },
                            },
                            [
                              _c("div", { staticClass: "d-flex flex-column" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "mr-5 pt-2 primary--text font-weight-bold body-1 d-flex align-center",
                                  },
                                  [
                                    _c("span", { staticClass: "mr-1" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("playerRecruitment.minMax")
                                        )
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    !_vm.minMaxDisabledByCurrentMatchDay
                                      ? _c(
                                          "v-tooltip",
                                          {
                                            attrs: {
                                              top: "",
                                              color: "lightSecondary lighten-4",
                                              "max-width": "300",
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "activator",
                                                  fn: function ({ on }) {
                                                    return [
                                                      _c(
                                                        "v-icon",
                                                        _vm._g(
                                                          {
                                                            attrs: {
                                                              color:
                                                                "secondary",
                                                              "x-small": "",
                                                            },
                                                          },
                                                          on
                                                        ),
                                                        [_vm._v("info")]
                                                      ),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              false,
                                              1899471869
                                            ),
                                          },
                                          [
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "d-flex flex-column align-center",
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "black--text body-1",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "playerRecruitment.minMaxTooltip"
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.minMaxDisabledByCurrentMatchDay
                                      ? _c(
                                          "v-tooltip",
                                          {
                                            attrs: {
                                              top: "",
                                              color: "lightSecondary lighten-4",
                                              "max-width": "300",
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "activator",
                                                  fn: function ({ on }) {
                                                    return [
                                                      _c(
                                                        "v-icon",
                                                        _vm._g(
                                                          {
                                                            staticClass: "ml-1",
                                                            attrs: {
                                                              color: "warning",
                                                              "x-small": "",
                                                            },
                                                          },
                                                          on
                                                        ),
                                                        [_vm._v("warning")]
                                                      ),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              false,
                                              4195022356
                                            ),
                                          },
                                          [
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "black--text body-1",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "playerRecruitment.infoMessage3"
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "pl-2 d-flex flex-wrap" },
                                  [
                                    _c(
                                      "v-radio-group",
                                      {
                                        staticClass: "mt-0 d-flex flex-column",
                                        attrs: {
                                          row: "",
                                          disabled:
                                            _vm.minMaxDisabledByCurrentMatchDay,
                                        },
                                        on: {
                                          change: function ($event) {
                                            return _vm.minMaxChange()
                                          },
                                        },
                                        model: {
                                          value: _vm.minMaxModel,
                                          callback: function ($$v) {
                                            _vm.minMaxModel = $$v
                                          },
                                          expression: "minMaxModel",
                                        },
                                      },
                                      [
                                        _c("v-radio", {
                                          attrs: {
                                            value: "top5Leagues",
                                            color: "secondary",
                                          },
                                          scopedSlots: _vm._u([
                                            {
                                              key: "label",
                                              fn: function () {
                                                return [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "body-1 primary--text font-weight-medium",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            `playerRecruitment.top5Leagues`
                                                          )
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              },
                                              proxy: true,
                                            },
                                          ]),
                                        }),
                                        _vm._v(" "),
                                        !_vm.seasonMinMaxRadioDisabled &&
                                        !_vm.seasonMinMaxRadioLollipopDisabled
                                          ? _c("v-radio", {
                                              attrs: {
                                                value: "selectedSeason",
                                                color: "secondary",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "label",
                                                    fn: function () {
                                                      return [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "body-1 primary--text font-weight-medium",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  `playerRecruitment.selectedSeason`
                                                                )
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    },
                                                    proxy: true,
                                                  },
                                                ],
                                                null,
                                                false,
                                                3002113476
                                              ),
                                            })
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.seasonMinMaxRadioDisabled
                                          ? _c(
                                              "v-tooltip",
                                              {
                                                attrs: {
                                                  top: "",
                                                  color:
                                                    "lightSecondary lighten-4",
                                                  "max-width": "300",
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "activator",
                                                      fn: function ({ on }) {
                                                        return [
                                                          _c(
                                                            "v-radio",
                                                            _vm._g(
                                                              {
                                                                attrs: {
                                                                  value:
                                                                    "selectedSeason",
                                                                  readonly: true,
                                                                  color:
                                                                    "secondary",
                                                                },
                                                                scopedSlots:
                                                                  _vm._u(
                                                                    [
                                                                      {
                                                                        key: "label",
                                                                        fn: function () {
                                                                          return [
                                                                            _c(
                                                                              "span",
                                                                              _vm._g(
                                                                                {
                                                                                  staticClass:
                                                                                    "body-1 primary--text font-weight-medium",
                                                                                },
                                                                                on
                                                                              ),
                                                                              [
                                                                                _vm._v(
                                                                                  _vm._s(
                                                                                    _vm.$t(
                                                                                      `playerRecruitment.selectedSeason`
                                                                                    )
                                                                                  )
                                                                                ),
                                                                              ]
                                                                            ),
                                                                          ]
                                                                        },
                                                                        proxy: true,
                                                                      },
                                                                    ],
                                                                    null,
                                                                    true
                                                                  ),
                                                              },
                                                              on
                                                            )
                                                          ),
                                                        ]
                                                      },
                                                    },
                                                  ],
                                                  null,
                                                  false,
                                                  3942369402
                                                ),
                                              },
                                              [
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "black--text body-1",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          `playerRecruitment.infoMessage`
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        !_vm.seasonMinMaxRadioDisabled &&
                                        _vm.seasonMinMaxRadioLollipopDisabled
                                          ? _c(
                                              "v-tooltip",
                                              {
                                                attrs: {
                                                  top: "",
                                                  color:
                                                    "lightSecondary lighten-4",
                                                  "max-width": "300",
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "activator",
                                                      fn: function ({ on }) {
                                                        return [
                                                          _c(
                                                            "v-radio",
                                                            _vm._g(
                                                              {
                                                                attrs: {
                                                                  value: false,
                                                                  readonly: true,
                                                                  color:
                                                                    "secondary",
                                                                },
                                                                scopedSlots:
                                                                  _vm._u(
                                                                    [
                                                                      {
                                                                        key: "label",
                                                                        fn: function () {
                                                                          return [
                                                                            _c(
                                                                              "span",
                                                                              _vm._g(
                                                                                {
                                                                                  staticClass:
                                                                                    "body-1 primary--text font-weight-medium",
                                                                                },
                                                                                on
                                                                              ),
                                                                              [
                                                                                _vm._v(
                                                                                  _vm._s(
                                                                                    _vm.$t(
                                                                                      `playerRecruitment.selectedSeason`
                                                                                    )
                                                                                  )
                                                                                ),
                                                                              ]
                                                                            ),
                                                                          ]
                                                                        },
                                                                        proxy: true,
                                                                      },
                                                                    ],
                                                                    null,
                                                                    true
                                                                  ),
                                                              },
                                                              on
                                                            )
                                                          ),
                                                        ]
                                                      },
                                                    },
                                                  ],
                                                  null,
                                                  false,
                                                  3292205387
                                                ),
                                              },
                                              [
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "black--text body-1",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          `playerRecruitment.infoMessage2`
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.currentUserSeasonId &&
                                        _vm.currentUserSeasonId !=
                                          _vm.headerPlayer.seasonId
                                          ? _c("v-radio", {
                                              attrs: {
                                                value: "ownSeason",
                                                color: "primary",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "label",
                                                    fn: function () {
                                                      return [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "body-1 primary--text font-weight-medium",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  `playerRecruitment.ownSeason`
                                                                )
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    },
                                                    proxy: true,
                                                  },
                                                ],
                                                null,
                                                false,
                                                281065563
                                              ),
                                            })
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.isACTalentUser || _vm.isDLUsers
                                          ? _c("v-radio", {
                                              attrs: {
                                                value: "champions",
                                                color: "secondary",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "label",
                                                    fn: function () {
                                                      return [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "body-1 primary--text font-weight-medium",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                          A+/A\n                        "
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    },
                                                    proxy: true,
                                                  },
                                                ],
                                                null,
                                                false,
                                                3836294001
                                              ),
                                            })
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.isACTalentUser || _vm.isDLUsers
                                          ? _c("v-radio", {
                                              attrs: {
                                                value: "europa",
                                                color: "secondary",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "label",
                                                    fn: function () {
                                                      return [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "body-1 primary--text font-weight-medium",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                          B+\n                        "
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    },
                                                    proxy: true,
                                                  },
                                                ],
                                                null,
                                                false,
                                                2839827964
                                              ),
                                            })
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.isOrlegiUser
                                          ? _c("v-radio", {
                                              attrs: {
                                                value: "ligaMX",
                                                color: "secondary",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "label",
                                                    fn: function () {
                                                      return [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "body-1 primary--text font-weight-medium",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                          Liga MX\n                        "
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    },
                                                    proxy: true,
                                                  },
                                                ],
                                                null,
                                                false,
                                                3013645475
                                              ),
                                            })
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.isOrlegiUser
                                          ? _c("v-radio", {
                                              attrs: {
                                                value: "segundaDivision",
                                                color: "secondary",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "label",
                                                    fn: function () {
                                                      return [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "body-1 primary--text font-weight-medium",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                          Segunda División\n                        "
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    },
                                                    proxy: true,
                                                  },
                                                ],
                                                null,
                                                false,
                                                3481607503
                                              ),
                                            })
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.isDLUsers
                                          ? _c("v-radio", {
                                              attrs: {
                                                value: "latam",
                                                disabled:
                                                  !_vm.templateActive.cXY,
                                                color: "secondary",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "label",
                                                    fn: function () {
                                                      return [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "body-1 primary--text font-weight-medium",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                          Southamerica 7\n                        "
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    },
                                                    proxy: true,
                                                  },
                                                ],
                                                null,
                                                false,
                                                3181204743
                                              ),
                                            })
                                          : _vm._e(),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-row",
                        { attrs: { id: "player-compare-zone" } },
                        [
                          !_vm.stackedView &&
                          _vm.selectedTab !== "polar" &&
                          _vm.templateActive
                            ? _c(
                                "v-col",
                                {
                                  staticClass: "pt-0 pb-2",
                                  attrs: { cols: "12" },
                                },
                                [
                                  _c(
                                    "v-card-title",
                                    {
                                      staticClass: "pa-0 mb-0 header-font",
                                      staticStyle: { "font-size": "22px" },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("general.comparison"))
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.stackedView &&
                          _vm.selectedTab !== "polar" &&
                          _vm.templateActive
                            ? _c(
                                "v-col",
                                { staticClass: "py-0", attrs: { cols: "12" } },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "mr-5 primary--text font-weight-bold body-1",
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.$t(
                                              "playerRecruitment.compareWith"
                                            )
                                          ) +
                                          " " +
                                          _vm._s(
                                            _vm.$t(
                                              `playerRecruitment.previousPerformance`
                                            )
                                          ) +
                                          "\n                "
                                      ),
                                      !_vm.hasMinimumGames(20) ||
                                      !_vm.hasMinimumGames(12)
                                        ? _c(
                                            "v-tooltip",
                                            {
                                              attrs: {
                                                top: "",
                                                color:
                                                  "lightSecondary lighten-4",
                                                "max-width": "300",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "activator",
                                                    fn: function ({ on }) {
                                                      return [
                                                        _c(
                                                          "v-icon",
                                                          _vm._g(
                                                            {
                                                              attrs: {
                                                                color:
                                                                  "secondary",
                                                                "x-small": "",
                                                              },
                                                            },
                                                            on
                                                          ),
                                                          [_vm._v("info")]
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                false,
                                                1899471869
                                              ),
                                            },
                                            [
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "black--text body-1",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        `playerDetail.gamesPlayedNotEnough`
                                                      )
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _vm.playerSeasonsPlayed &&
                                  _vm.playerSeasonsPlayed.length
                                    ? _c(
                                        "v-radio-group",
                                        {
                                          staticClass: "mt-1 pl-2 py-0",
                                          attrs: {
                                            row: "",
                                            dense: "",
                                            "hide-details": "",
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.onAutoCompareChange()
                                            },
                                          },
                                          model: {
                                            value: _vm.autoCompareModel,
                                            callback: function ($$v) {
                                              _vm.autoCompareModel = $$v
                                            },
                                            expression: "autoCompareModel",
                                          },
                                        },
                                        [
                                          _c("v-radio", {
                                            staticClass: "my-0 mr-1",
                                            attrs: {
                                              value: "-1",
                                              label: _vm.$t(
                                                "charts.lastSeasonSelectText"
                                              ),
                                              disabled: _vm.loading,
                                              color: "secondary",
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "label",
                                                  fn: function () {
                                                    return [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "body-1 primary--text font-weight-medium",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "charts.lastSeasonSelectText"
                                                              )
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  },
                                                  proxy: true,
                                                },
                                              ],
                                              null,
                                              false,
                                              3936939522
                                            ),
                                          }),
                                          _vm._v(" "),
                                          _vm.selectedTab !== "performance-text"
                                            ? _c("v-radio", {
                                                staticClass: "my-0 mr-1",
                                                attrs: {
                                                  value: "12",
                                                  disabled:
                                                    !_vm.hasMinimumGames(20),
                                                  color: "secondary",
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "label",
                                                      fn: function () {
                                                        return [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "body-1 primary--text font-weight-medium",
                                                            },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "playerRecruitment.xGames",
                                                                      { 0: 12 }
                                                                    )
                                                                  )
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      },
                                                      proxy: true,
                                                    },
                                                  ],
                                                  null,
                                                  false,
                                                  481131141
                                                ),
                                              })
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.selectedTab !== "performance-text"
                                            ? _c("v-radio", {
                                                staticClass: "my-0 mr-1",
                                                attrs: {
                                                  value: "6",
                                                  disabled:
                                                    !_vm.hasMinimumGames(12),
                                                  color: "secondary",
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "label",
                                                      fn: function () {
                                                        return [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "body-1 primary--text font-weight-medium",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "playerRecruitment.xGames",
                                                                    { 0: 6 }
                                                                  )
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      },
                                                      proxy: true,
                                                    },
                                                  ],
                                                  null,
                                                  false,
                                                  1511585691
                                                ),
                                              })
                                            : _vm._e(),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "v-row",
                                    { staticClass: "py-2" },
                                    [
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "py-0",
                                          attrs: { cols: "12", md: "6" },
                                        },
                                        [
                                          _c(
                                            "p",
                                            {
                                              staticClass:
                                                "body-1 font-weight-bold primary--text pb-1 mb-0 me-3",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "game.gameAnalysis.from"
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-menu",
                                            {
                                              attrs: {
                                                "close-on-content-click": false,
                                                "nudge-right": 40,
                                                transition: "scale-transition",
                                                "offset-y": "",
                                                "content-class":
                                                  "compare-date-menu",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "activator",
                                                    fn: function ({
                                                      on,
                                                      attrs,
                                                    }) {
                                                      return [
                                                        _c(
                                                          "v-text-field",
                                                          _vm._g(
                                                            _vm._b(
                                                              {
                                                                staticClass:
                                                                  "body-1 slim-input",
                                                                attrs: {
                                                                  readonly: "",
                                                                  clearable: "",
                                                                  dense: "",
                                                                  outlined: "",
                                                                  "hide-details":
                                                                    "",
                                                                },
                                                                on: {
                                                                  "click:clear":
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.onClearDate(
                                                                        0
                                                                      )
                                                                    },
                                                                },
                                                                scopedSlots:
                                                                  _vm._u(
                                                                    [
                                                                      {
                                                                        key: "prepend-inner",
                                                                        fn: function () {
                                                                          return [
                                                                            _c(
                                                                              "v-icon",
                                                                              {
                                                                                staticStyle:
                                                                                  {
                                                                                    "font-size":
                                                                                      "24px",
                                                                                  },
                                                                                attrs:
                                                                                  {
                                                                                    small:
                                                                                      "",
                                                                                  },
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  "\n                            event\n                          "
                                                                                ),
                                                                              ]
                                                                            ),
                                                                          ]
                                                                        },
                                                                        proxy: true,
                                                                      },
                                                                    ],
                                                                    null,
                                                                    true
                                                                  ),
                                                                model: {
                                                                  value:
                                                                    _vm.compareMatchDateFrom,
                                                                  callback:
                                                                    function (
                                                                      $$v
                                                                    ) {
                                                                      _vm.compareMatchDateFrom =
                                                                        $$v
                                                                    },
                                                                  expression:
                                                                    "compareMatchDateFrom",
                                                                },
                                                              },
                                                              "v-text-field",
                                                              attrs,
                                                              false
                                                            ),
                                                            on
                                                          )
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                false,
                                                2803374082
                                              ),
                                              model: {
                                                value: _vm.compareDateMenuFrom,
                                                callback: function ($$v) {
                                                  _vm.compareDateMenuFrom = $$v
                                                },
                                                expression:
                                                  "compareDateMenuFrom",
                                              },
                                            },
                                            [
                                              _vm._v(" "),
                                              _c("v-date-picker", {
                                                attrs: {
                                                  "no-title": "",
                                                  color: "secondary",
                                                  locale:
                                                    _vm.currentUserLanguage,
                                                  "first-day-of-week": 1,
                                                  max: _vm.maxFromDate,
                                                },
                                                on: {
                                                  input: function ($event) {
                                                    _vm.compareDateMenuFrom = false
                                                    _vm.setMatchDate(0)
                                                  },
                                                },
                                                model: {
                                                  value:
                                                    _vm.compareMatchDatePickerFrom,
                                                  callback: function ($$v) {
                                                    _vm.compareMatchDatePickerFrom =
                                                      $$v
                                                  },
                                                  expression:
                                                    "compareMatchDatePickerFrom",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "py-0",
                                          attrs: { cols: "12", md: "6" },
                                        },
                                        [
                                          _c(
                                            "p",
                                            {
                                              staticClass:
                                                "body-1 font-weight-bold primary--text pb-1 mb-0 me-3",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("game.gameAnalysis.to")
                                                )
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-menu",
                                            {
                                              attrs: {
                                                "close-on-content-click": false,
                                                "nudge-right": 40,
                                                transition: "scale-transition",
                                                "offset-y": "",
                                                "content-class":
                                                  "compare-date-menu",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "activator",
                                                    fn: function ({
                                                      on,
                                                      attrs,
                                                    }) {
                                                      return [
                                                        _c(
                                                          "v-text-field",
                                                          _vm._g(
                                                            _vm._b(
                                                              {
                                                                staticClass:
                                                                  "body-1 slim-input",
                                                                attrs: {
                                                                  readonly: "",
                                                                  clearable: "",
                                                                  dense: "",
                                                                  outlined: "",
                                                                  "hide-details":
                                                                    "",
                                                                },
                                                                on: {
                                                                  "click:clear":
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.onClearDate(
                                                                        1
                                                                      )
                                                                    },
                                                                },
                                                                scopedSlots:
                                                                  _vm._u(
                                                                    [
                                                                      {
                                                                        key: "prepend-inner",
                                                                        fn: function () {
                                                                          return [
                                                                            _c(
                                                                              "v-icon",
                                                                              {
                                                                                staticStyle:
                                                                                  {
                                                                                    "font-size":
                                                                                      "24px",
                                                                                  },
                                                                                attrs:
                                                                                  {
                                                                                    small:
                                                                                      "",
                                                                                  },
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  "\n                            event\n                          "
                                                                                ),
                                                                              ]
                                                                            ),
                                                                          ]
                                                                        },
                                                                        proxy: true,
                                                                      },
                                                                    ],
                                                                    null,
                                                                    true
                                                                  ),
                                                                model: {
                                                                  value:
                                                                    _vm.compareMatchDateTo,
                                                                  callback:
                                                                    function (
                                                                      $$v
                                                                    ) {
                                                                      _vm.compareMatchDateTo =
                                                                        $$v
                                                                    },
                                                                  expression:
                                                                    "compareMatchDateTo",
                                                                },
                                                              },
                                                              "v-text-field",
                                                              attrs,
                                                              false
                                                            ),
                                                            on
                                                          )
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                false,
                                                1198529774
                                              ),
                                              model: {
                                                value: _vm.compareDateMenuTo,
                                                callback: function ($$v) {
                                                  _vm.compareDateMenuTo = $$v
                                                },
                                                expression: "compareDateMenuTo",
                                              },
                                            },
                                            [
                                              _vm._v(" "),
                                              _c("v-date-picker", {
                                                attrs: {
                                                  "no-title": "",
                                                  color: "secondary",
                                                  locale:
                                                    _vm.currentUserLanguage,
                                                  "first-day-of-week": 1,
                                                  min: _vm.minToDate,
                                                  max: _vm.todayDate,
                                                },
                                                on: {
                                                  input: function ($event) {
                                                    _vm.compareDateMenuTo = false
                                                    _vm.setMatchDate(1)
                                                  },
                                                },
                                                model: {
                                                  value:
                                                    _vm.compareMatchDatePickerTo,
                                                  callback: function ($$v) {
                                                    _vm.compareMatchDatePickerTo =
                                                      $$v
                                                  },
                                                  expression:
                                                    "compareMatchDatePickerTo",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _vm.showGamesBetweenDatesError
                                        ? _c(
                                            "v-col",
                                            {
                                              staticClass: "pt-1",
                                              attrs: { cols: "12" },
                                            },
                                            [
                                              _c(
                                                "p",
                                                {
                                                  staticClass:
                                                    "caption error--text mb-0",
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "playerRecruitment.noGamesBetweenDates"
                                                        )
                                                      ) +
                                                      "\n                  "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.playerSeasonsPlayed &&
                          ["radar", "lollipop"].includes(_vm.selectedTab)
                            ? _c(
                                "v-col",
                                { staticClass: "pt-1", attrs: { cols: "12" } },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "mr-5 pt-0 mt-0 primary--text font-weight-bold body-1",
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.$t(
                                              "playerRecruitment.compareWith"
                                            )
                                          ) +
                                          " " +
                                          _vm._s(
                                            _vm.$t(
                                              "playerRecruitment.leagueAverage"
                                            )
                                          ) +
                                          "\n              "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("v-autocomplete", {
                                    staticClass: "w-100",
                                    attrs: {
                                      items: _vm.leaguesAverage,
                                      "return-object": "",
                                      placeholder: _vm.$t(
                                        "playerRecruitment.selectSeason"
                                      ),
                                      "hide-details": "",
                                      dense: "",
                                      clearable: "",
                                      "item-value": "seasonId",
                                      "item-text": "seasonName",
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.onLeagueAverageChange($event)
                                      },
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "selection",
                                          fn: function ({ item, index }) {
                                            return [
                                              index <= 2
                                                ? _c(
                                                    "v-chip",
                                                    {
                                                      staticClass:
                                                        "body-2 mb-1 black--text",
                                                      attrs: {
                                                        small: "",
                                                        color:
                                                          "lightSecondary lighten-2",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "object",
                                                        {
                                                          staticClass: "mr-2",
                                                          attrs: {
                                                            data: `https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/leagues/${item.leagueId}.png`,
                                                            type: "image/png",
                                                            height: "20",
                                                          },
                                                        },
                                                        [
                                                          _c("img", {
                                                            attrs: {
                                                              src: `https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/0.png`,
                                                              height: "20",
                                                            },
                                                          }),
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "font-weight-bold",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              item.seasonName
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              index === 3
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "primary--text body-2 subheader-font",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "(+" +
                                                          _vm._s(
                                                            _vm
                                                              .seasonDataSelectedCheckBoxModel
                                                              .length - 3
                                                          ) +
                                                          " " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "finishingMap.more"
                                                            )
                                                          ) +
                                                          ")"
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ]
                                          },
                                        },
                                        {
                                          key: "item",
                                          fn: function ({ item }) {
                                            return [
                                              _c(
                                                "v-card-text",
                                                {
                                                  staticClass:
                                                    "pa-0 primary--text body-1 font-weight-medium d-flex flex-column align-start justify-center",
                                                },
                                                [
                                                  _c("div", [
                                                    _c(
                                                      "object",
                                                      {
                                                        staticClass: "mr-2",
                                                        attrs: {
                                                          data: `https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/leagues/${item.leagueId}.png`,
                                                          type: "image/png",
                                                          height: "18",
                                                        },
                                                      },
                                                      [
                                                        _c("img", {
                                                          attrs: {
                                                            src: `https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/0.png`,
                                                            height: "15",
                                                          },
                                                        }),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(item.seasonName)
                                                      ),
                                                    ]),
                                                  ]),
                                                  _vm._v(" "),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "body-2 subheader-font",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                      " +
                                                          _vm._s(
                                                            item.teamName
                                                          ) +
                                                          " \n                      "
                                                      ),
                                                      item.minutesPlayedPD &&
                                                      _vm.templateActive &&
                                                      (_vm.templateActive.cPD ||
                                                        _vm.templateActive.cA)
                                                        ? _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "ms-1",
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                        " +
                                                                  _vm._s(
                                                                    `(${
                                                                      item.minutesPlayedPD
                                                                    } ${_vm.$t(
                                                                      "table.history.minutes"
                                                                    )})`
                                                                  ) +
                                                                  "\n                      "
                                                              ),
                                                            ]
                                                          )
                                                        : item.minutesPlayed
                                                        ? _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "ms-1",
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                        " +
                                                                  _vm._s(
                                                                    `(${
                                                                      item.minutesPlayed
                                                                    } ${_vm.$t(
                                                                      "table.history.minutes"
                                                                    )})`
                                                                  ) +
                                                                  "\n                      "
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      655478246
                                    ),
                                    model: {
                                      value: _vm.leaguesAverageObjectModel,
                                      callback: function ($$v) {
                                        _vm.leaguesAverageObjectModel = $$v
                                      },
                                      expression: "leaguesAverageObjectModel",
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.stackedView && _vm.selectedTab !== "polar"
                            ? _c(
                                "v-col",
                                { staticClass: "py-0", attrs: { cols: "12" } },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "mr-5 primary--text font-weight-bold body-1",
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.$t(
                                              "playerRecruitment.compareWith"
                                            )
                                          ) +
                                          " "
                                      ),
                                      !_vm.notFilterByPosition
                                        ? _c("span", { staticClass: "mr-1" }, [
                                            _vm._v(
                                              _vm._s(
                                                _vm.templateActivePosition
                                                  ? _vm.$t(
                                                      `playerRecruitment.radarTemplates.${_vm.templateActivePosition}`
                                                    )
                                                  : ""
                                              )
                                            ),
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.templateActivePosition &&
                                      !_vm.notFilterByPosition
                                        ? _c(
                                            "v-tooltip",
                                            {
                                              attrs: {
                                                top: "",
                                                color:
                                                  "lightSecondary lighten-4",
                                                "max-width": "300",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "activator",
                                                    fn: function ({ on }) {
                                                      return [
                                                        _c(
                                                          "v-icon",
                                                          _vm._g(
                                                            {
                                                              attrs: {
                                                                color:
                                                                  "secondary",
                                                                "x-small": "",
                                                              },
                                                            },
                                                            on
                                                          ),
                                                          [_vm._v("info")]
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                false,
                                                1899471869
                                              ),
                                            },
                                            [
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "d-flex flex-column align-center",
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "black--text body-1",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            `playerDetail.onlyPlayersThatFit`
                                                          )
                                                        ) + " "
                                                      ),
                                                      _c("b", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.templateActivePosition
                                                              ? _vm.$t(
                                                                  `playerRecruitment.radarTemplates.${_vm.templateActivePosition}`
                                                                )
                                                              : ""
                                                          )
                                                        ),
                                                      ]),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "d-flex align-center",
                                                    },
                                                    _vm._l(
                                                      _vm.getPositionsByTemplate(),
                                                      function (pos, index) {
                                                        return _c(
                                                          "v-chip",
                                                          {
                                                            key: index,
                                                            staticClass:
                                                              "monospace-font",
                                                            staticStyle: {
                                                              height: "20px",
                                                              margin: "1px",
                                                            },
                                                            attrs: {
                                                              color:
                                                                _vm.getPositionChip(
                                                                  pos
                                                                ),
                                                              "text-color":
                                                                "white",
                                                              small: "",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.getPositionCode(
                                                                  pos
                                                                )
                                                              )
                                                            ),
                                                          ]
                                                        )
                                                      }
                                                    ),
                                                    1
                                                  ),
                                                ]
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "pl-2 d-flex flex-wrap" },
                                    [
                                      _c("SearchBar", {
                                        staticClass: "px-0 pt-0 mb-3 w-100",
                                        attrs: {
                                          placeholder:
                                            "playerComparison.searchBarPlaceholder",
                                          icon: "person_add",
                                          dataSet: _vm.dataSetFiltered,
                                          navigate: false,
                                          playersResults: 5,
                                          showTeams: false,
                                          showGames: false,
                                          showLeagues: false,
                                          showMore: false,
                                          noResultPlaceHolder: true,
                                          noResultPlaceHolderTemplate: _vm.$t(
                                            `playerRecruitment.radarTemplates.${_vm.templateActivePosition}`
                                          ),
                                        },
                                        on: {
                                          resultClicked: function ($event) {
                                            return _vm.onResultClicked($event)
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _vm.selectedPlayer
                                    ? _c(
                                        "div",
                                        { staticClass: "d-flex" },
                                        [
                                          _c("PlayerSearchItem", {
                                            staticClass: "mr-3 flex-grow-1",
                                            attrs: {
                                              player: _vm.selectedPlayer,
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "v-icon",
                                            {
                                              on: {
                                                click: function ($event) {
                                                  return _vm.clearSearchItems()
                                                },
                                              },
                                            },
                                            [_vm._v("cancel")]
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.stackedView &&
                          _vm.selectedTab !== "polar" &&
                          _vm.comparePlayerSeasonData &&
                          _vm.comparePlayerSeasonData.length >= 8
                            ? _c(
                                "v-col",
                                {
                                  staticClass: "pt-1",
                                  staticStyle: { "z-index": "1001" },
                                  attrs: { cols: "12" },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "mr-5 pt-0 mt-0 primary--text font-weight-bold body-1",
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(_vm.$t("app.seasonStats")) +
                                          "\n              "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm.showSeasonsAsCheckbox
                                    ? _c("v-autocomplete", {
                                        attrs: {
                                          clearable: "",
                                          items:
                                            _vm.comparePlayerSeasonDataFiltered,
                                          multiple: "",
                                          "hide-details": "",
                                          dense: "",
                                          "item-value": "compoundId",
                                          "item-text": "compoundText",
                                        },
                                        on: {
                                          change: function ($event) {
                                            return _vm.onAutoCompleteCompareSeasonChange(
                                              $event
                                            )
                                          },
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "selection",
                                              fn: function ({ item, index }) {
                                                return [
                                                  index <= 2
                                                    ? _c(
                                                        "v-chip",
                                                        {
                                                          staticClass:
                                                            "body-2 mb-1 black--text",
                                                          attrs: {
                                                            small: "",
                                                            color:
                                                              "lightSecondary lighten-2",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "object",
                                                            {
                                                              staticClass:
                                                                "mr-2",
                                                              attrs: {
                                                                data: `https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/leagues/${item.leagueId}.png`,
                                                                type: "image/png",
                                                                height: "20",
                                                              },
                                                            },
                                                            [
                                                              _c("img", {
                                                                attrs: {
                                                                  src: `https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/0.png`,
                                                                  height: "20",
                                                                },
                                                              }),
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "font-weight-bold",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  item.seasonName
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "mx-1",
                                                            },
                                                            [_vm._v("@")]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "font-weight-medium",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  item.teamName
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  index === 3
                                                    ? _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "primary--text body-2 subheader-font",
                                                        },
                                                        [
                                                          _vm._v(
                                                            "(+" +
                                                              _vm._s(
                                                                _vm
                                                                  .seasonDataSelectedCheckBoxModel
                                                                  .length - 3
                                                              ) +
                                                              " " +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "finishingMap.more"
                                                                )
                                                              ) +
                                                              ")"
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                ]
                                              },
                                            },
                                            {
                                              key: "item",
                                              fn: function ({ item }) {
                                                return [
                                                  _c(
                                                    "v-card-text",
                                                    {
                                                      staticClass:
                                                        "px-0 py-1 primary--text body-2 font-weight-medium d-flex flex-column align-start justify-center",
                                                    },
                                                    [
                                                      _c("div", [
                                                        _c(
                                                          "object",
                                                          {
                                                            staticClass: "mr-2",
                                                            attrs: {
                                                              data: `https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/leagues/${item.leagueId}.png`,
                                                              type: "image/png",
                                                              height: "18",
                                                            },
                                                          },
                                                          [
                                                            _c("img", {
                                                              attrs: {
                                                                src: `https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/0.png`,
                                                                height: "15",
                                                              },
                                                            }),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              item.seasonName
                                                            )
                                                          ),
                                                        ]),
                                                      ]),
                                                      _vm._v(" "),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "body-2 subheader-font",
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                      " +
                                                              _vm._s(
                                                                item.teamName
                                                              ) +
                                                              " \n                      "
                                                          ),
                                                          item.minutesPlayedPD &&
                                                          _vm.templateActive &&
                                                          (_vm.templateActive
                                                            .cPD ||
                                                            _vm.templateActive
                                                              .cA)
                                                            ? _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "ms-1",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                        " +
                                                                      _vm._s(
                                                                        `(${
                                                                          item.minutesPlayedPD
                                                                        } ${_vm.$t(
                                                                          "table.history.minutes"
                                                                        )})`
                                                                      ) +
                                                                      "\n                      "
                                                                  ),
                                                                ]
                                                              )
                                                            : item.minutesPlayed
                                                            ? _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "ms-1",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                        " +
                                                                      _vm._s(
                                                                        `(${
                                                                          item.minutesPlayed
                                                                        } ${_vm.$t(
                                                                          "table.history.minutes"
                                                                        )})`
                                                                      ) +
                                                                      "\n                      "
                                                                  ),
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          4164546050
                                        ),
                                        model: {
                                          value:
                                            _vm.seasonDataComparePlayerSelectedCheckBoxModel,
                                          callback: function ($$v) {
                                            _vm.seasonDataComparePlayerSelectedCheckBoxModel =
                                              $$v
                                          },
                                          expression:
                                            "seasonDataComparePlayerSelectedCheckBoxModel",
                                        },
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  !_vm.showSeasonsAsCheckbox
                                    ? _c("v-autocomplete", {
                                        attrs: {
                                          clearable: "",
                                          items:
                                            _vm.comparePlayerSeasonDataFiltered,
                                          "hide-details": "",
                                          dense: "",
                                          "item-value": "compoundId",
                                          "item-text": "compoundText",
                                        },
                                        on: {
                                          change: function ($event) {
                                            return _vm.onAutoCompleteCompareSeasonChange(
                                              $event
                                            )
                                          },
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "selection",
                                              fn: function ({ item }) {
                                                return [
                                                  _c(
                                                    "v-chip",
                                                    {
                                                      staticClass:
                                                        "body-2 mb-1 black--text",
                                                      attrs: {
                                                        small: "",
                                                        color:
                                                          "lightSecondary lighten-2",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "object",
                                                        {
                                                          staticClass: "mr-2",
                                                          attrs: {
                                                            data: `https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/leagues/${item.leagueId}.png`,
                                                            type: "image/png",
                                                            height: "20",
                                                          },
                                                        },
                                                        [
                                                          _c("img", {
                                                            attrs: {
                                                              src: `https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/0.png`,
                                                              height: "20",
                                                            },
                                                          }),
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "font-weight-bold",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              item.seasonName
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "span",
                                                        { staticClass: "mx-1" },
                                                        [_vm._v("@")]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "font-weight-medium",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              item.teamName
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              },
                                            },
                                            {
                                              key: "item",
                                              fn: function ({ item }) {
                                                return [
                                                  _c(
                                                    "v-card-text",
                                                    {
                                                      staticClass:
                                                        "px-0 py-1 primary--text body-2 font-weight-medium d-flex flex-column align-start justify-center",
                                                    },
                                                    [
                                                      _c("div", [
                                                        _c(
                                                          "object",
                                                          {
                                                            staticClass: "mr-2",
                                                            attrs: {
                                                              data: `https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/leagues/${item.leagueId}.png`,
                                                              type: "image/png",
                                                              height: "18",
                                                            },
                                                          },
                                                          [
                                                            _c("img", {
                                                              attrs: {
                                                                src: `https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/0.png`,
                                                                height: "15",
                                                              },
                                                            }),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              item.seasonName
                                                            )
                                                          ),
                                                        ]),
                                                      ]),
                                                      _vm._v(" "),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "body-2 subheader-font",
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                      " +
                                                              _vm._s(
                                                                item.teamName
                                                              ) +
                                                              " \n                      "
                                                          ),
                                                          item.minutesPlayedPD &&
                                                          _vm.templateActive &&
                                                          (_vm.templateActive
                                                            .cPD ||
                                                            _vm.templateActive
                                                              .cA)
                                                            ? _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "ms-1",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                        " +
                                                                      _vm._s(
                                                                        `(${
                                                                          item.minutesPlayedPD
                                                                        } ${_vm.$t(
                                                                          "table.history.minutes"
                                                                        )})`
                                                                      ) +
                                                                      "\n                      "
                                                                  ),
                                                                ]
                                                              )
                                                            : item.minutesPlayed
                                                            ? _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "ms-1",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                        " +
                                                                      _vm._s(
                                                                        `(${
                                                                          item.minutesPlayed
                                                                        } ${_vm.$t(
                                                                          "table.history.minutes"
                                                                        )})`
                                                                      ) +
                                                                      "\n                      "
                                                                  ),
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          3817534024
                                        ),
                                        model: {
                                          value:
                                            _vm.seasonDataComparePlayerSelectedRadiosModel,
                                          callback: function ($$v) {
                                            _vm.seasonDataComparePlayerSelectedRadiosModel =
                                              $$v
                                          },
                                          expression:
                                            "seasonDataComparePlayerSelectedRadiosModel",
                                        },
                                      })
                                    : _vm._e(),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.stackedView &&
                          _vm.selectedTab !== "polar" &&
                          _vm.showSeasonsAsCheckbox &&
                          _vm.comparePlayerSeasonData &&
                          _vm.comparePlayerSeasonData.length < 8
                            ? _c(
                                "v-col",
                                {
                                  staticClass: "d-flex py-0 pr-1 flex-column",
                                  attrs: { cols: "12" },
                                },
                                _vm._l(
                                  _vm.comparePlayerSeasonDataCurrentYear,
                                  function (seasonData, index) {
                                    return _c("v-checkbox", {
                                      key: index,
                                      staticClass: "px-2 mt-0 py-1",
                                      attrs: {
                                        value: `${seasonData.seasonId}-${seasonData.teamId}`,
                                        disabled: seasonData.disabled,
                                        color: "secondary",
                                        "hide-details": "",
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.onComparePlayerSeasonChange(
                                            seasonData
                                          )
                                        },
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "label",
                                            fn: function () {
                                              return [
                                                _c(
                                                  "v-card-text",
                                                  {
                                                    staticClass:
                                                      "pa-0 primary--text body-1 font-weight-medium d-flex flex-column align-start justify-center",
                                                  },
                                                  [
                                                    _c("div", [
                                                      _c(
                                                        "object",
                                                        {
                                                          staticClass: "mr-2",
                                                          attrs: {
                                                            data: `https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/leagues/${seasonData.leagueId}.png`,
                                                            type: "image/png",
                                                            height: "18",
                                                          },
                                                        },
                                                        [
                                                          _c("img", {
                                                            attrs: {
                                                              src: `https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/0.png`,
                                                              height: "15",
                                                            },
                                                          }),
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            seasonData.seasonName
                                                          )
                                                        ),
                                                      ]),
                                                    ]),
                                                    _vm._v(" "),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "body-2 subheader-font",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                      " +
                                                            _vm._s(
                                                              seasonData.teamName
                                                            ) +
                                                            " \n                      "
                                                        ),
                                                        seasonData.minutesPlayed
                                                          ? _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "ms-1",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    `(${
                                                                      seasonData.minutesPlayed
                                                                    } ${_vm.$t(
                                                                      "table.history.minutes"
                                                                    )})`
                                                                  )
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            },
                                            proxy: true,
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                      model: {
                                        value:
                                          _vm.seasonDataComparePlayerSelectedCheckBoxModel,
                                        callback: function ($$v) {
                                          _vm.seasonDataComparePlayerSelectedCheckBoxModel =
                                            $$v
                                        },
                                        expression:
                                          "seasonDataComparePlayerSelectedCheckBoxModel",
                                      },
                                    })
                                  }
                                ),
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm._l(
                            _vm.comparePlayerSeasonDataCurrentYear,
                            function (seasonData, index) {
                              return !_vm.stackedView &&
                                _vm.selectedTab !== "polar" &&
                                !_vm.showSeasonsAsCheckbox &&
                                _vm.comparePlayerSeasonDataCurrentYear.length >
                                  0 &&
                                _vm.comparePlayerSeasonData.length < 8
                                ? _c(
                                    "v-col",
                                    {
                                      key: index,
                                      staticClass: "d-flex py-0 pr-1",
                                      attrs: { cols: "12" },
                                    },
                                    [
                                      _c(
                                        "v-radio-group",
                                        {
                                          staticClass:
                                            "mt-0 d-flex flex-column",
                                          attrs: {
                                            value: `${seasonData.seasonId}-${seasonData.teamId}`,
                                            row: "",
                                            dense: "",
                                            "hide-details": "",
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.onComparePlayerSeasonChange(
                                                seasonData
                                              )
                                            },
                                          },
                                          model: {
                                            value:
                                              _vm.seasonDataComparePlayerSelectedRadiosModel,
                                            callback: function ($$v) {
                                              _vm.seasonDataComparePlayerSelectedRadiosModel =
                                                $$v
                                            },
                                            expression:
                                              "seasonDataComparePlayerSelectedRadiosModel",
                                          },
                                        },
                                        [
                                          _c("v-radio", {
                                            key: index,
                                            staticClass: "px-2 mt-0",
                                            attrs: {
                                              value: `${seasonData.seasonId}-${seasonData.teamId}`,
                                              color: "secondary",
                                              disabled: seasonData.disabled,
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "label",
                                                  fn: function () {
                                                    return [
                                                      _c(
                                                        "v-card-text",
                                                        {
                                                          staticClass:
                                                            "pa-0 primary--text body-2 font-weight-medium d-flex flex-column align-start justify-center",
                                                        },
                                                        [
                                                          _c("div", [
                                                            _c(
                                                              "object",
                                                              {
                                                                staticClass:
                                                                  "mr-2",
                                                                attrs: {
                                                                  data: `https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/leagues/${seasonData.leagueId}.png`,
                                                                  type: "image/png",
                                                                  height: "18",
                                                                },
                                                              },
                                                              [
                                                                _c("img", {
                                                                  attrs: {
                                                                    src: `https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/0.png`,
                                                                    height:
                                                                      "15",
                                                                  },
                                                                }),
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c("span", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  seasonData.seasonName
                                                                )
                                                              ),
                                                            ]),
                                                          ]),
                                                          _vm._v(" "),
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "body-2 subheader-font",
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                        " +
                                                                  _vm._s(
                                                                    seasonData.teamName
                                                                  ) +
                                                                  " \n                        "
                                                              ),
                                                              seasonData.minutesPlayed
                                                                ? _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "ms-1",
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          `(${
                                                                            seasonData.minutesPlayed
                                                                          } ${_vm.$t(
                                                                            "table.history.minutes"
                                                                          )})`
                                                                        )
                                                                      ),
                                                                    ]
                                                                  )
                                                                : _vm._e(),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  },
                                                  proxy: true,
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e()
                            }
                          ),
                          _vm._v(" "),
                          !_vm.stackedView &&
                          _vm.selectedTab !== "polar" &&
                          _vm.comparePlayerSeasonData &&
                          _vm.comparePlayerSeasonData.length < 8
                            ? _c(
                                "v-col",
                                {
                                  staticClass: "d-flex py-0 align-start pr-0",
                                  attrs: { cols: "12" },
                                },
                                [
                                  _vm.comparePlayerSeasonDataLastYear
                                    ? _c(
                                        "v-row",
                                        [
                                          _vm._l(
                                            _vm.comparePlayerSeasonDataLastYear,
                                            function (seasonData, index) {
                                              return _vm.showSeasonsAsCheckbox
                                                ? _c(
                                                    "v-col",
                                                    {
                                                      key: index,
                                                      staticClass:
                                                        "d-flex py-0 pr-1",
                                                      attrs: {
                                                        cols: "12",
                                                        sm: "12",
                                                      },
                                                    },
                                                    [
                                                      _c("v-checkbox", {
                                                        key: index,
                                                        staticClass:
                                                          "px-2 mt-0 py-1",
                                                        attrs: {
                                                          value: `${seasonData.seasonId}-${seasonData.teamId}`,
                                                          disabled:
                                                            seasonData.disabled,
                                                          "hide-details": "",
                                                          color: "secondary",
                                                        },
                                                        on: {
                                                          change: function (
                                                            $event
                                                          ) {
                                                            return _vm.onComparePlayerSeasonChange(
                                                              seasonData
                                                            )
                                                          },
                                                        },
                                                        scopedSlots: _vm._u(
                                                          [
                                                            {
                                                              key: "label",
                                                              fn: function () {
                                                                return [
                                                                  _c(
                                                                    "v-card-text",
                                                                    {
                                                                      staticClass:
                                                                        "pa-0 primary--text body-2 font-weight-medium d-flex flex-column align-start justify-center",
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "div",
                                                                        [
                                                                          _c(
                                                                            "object",
                                                                            {
                                                                              staticClass:
                                                                                "mr-2",
                                                                              attrs:
                                                                                {
                                                                                  data: `https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/leagues/${seasonData.leagueId}.png`,
                                                                                  type: "image/png",
                                                                                  height:
                                                                                    "18",
                                                                                },
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "img",
                                                                                {
                                                                                  attrs:
                                                                                    {
                                                                                      src: `https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/0.png`,
                                                                                      height:
                                                                                        "15",
                                                                                    },
                                                                                }
                                                                              ),
                                                                            ]
                                                                          ),
                                                                          _vm._v(
                                                                            " "
                                                                          ),
                                                                          _c(
                                                                            "span",
                                                                            [
                                                                              _vm._v(
                                                                                _vm._s(
                                                                                  seasonData.seasonName
                                                                                )
                                                                              ),
                                                                            ]
                                                                          ),
                                                                        ]
                                                                      ),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _c(
                                                                        "span",
                                                                        {
                                                                          staticClass:
                                                                            "body-2 subheader-font",
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "\n                          " +
                                                                              _vm._s(
                                                                                seasonData.teamName
                                                                              ) +
                                                                              " \n                          "
                                                                          ),
                                                                          seasonData.minutesPlayed
                                                                            ? _c(
                                                                                "span",
                                                                                {
                                                                                  staticClass:
                                                                                    "ms-1",
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    _vm._s(
                                                                                      `(${
                                                                                        seasonData.minutesPlayed
                                                                                      } ${_vm.$t(
                                                                                        "table.history.minutes"
                                                                                      )})`
                                                                                    )
                                                                                  ),
                                                                                ]
                                                                              )
                                                                            : _vm._e(),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              },
                                                              proxy: true,
                                                            },
                                                          ],
                                                          null,
                                                          true
                                                        ),
                                                        model: {
                                                          value:
                                                            _vm.seasonDataComparePlayerSelectedCheckBoxModel,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.seasonDataComparePlayerSelectedCheckBoxModel =
                                                              $$v
                                                          },
                                                          expression:
                                                            "seasonDataComparePlayerSelectedCheckBoxModel",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  )
                                                : _vm._e()
                                            }
                                          ),
                                          _vm._v(" "),
                                          _vm._l(
                                            _vm.comparePlayerSeasonDataLastYear,
                                            function (seasonData, index) {
                                              return !_vm.showSeasonsAsCheckbox
                                                ? _c(
                                                    "v-col",
                                                    {
                                                      key: index,
                                                      staticClass:
                                                        "d-flex py-0 pr-1",
                                                      attrs: {
                                                        cols: "12",
                                                        sm: "12",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "v-radio-group",
                                                        {
                                                          staticClass:
                                                            "mt-0 py-0 d-flex flex-column",
                                                          attrs: {
                                                            value: `${seasonData.seasonId}-${seasonData.teamId}`,
                                                            row: "",
                                                            dense: "",
                                                            "hide-details": "",
                                                          },
                                                          on: {
                                                            change: function (
                                                              $event
                                                            ) {
                                                              return _vm.onComparePlayerSeasonChange(
                                                                seasonData
                                                              )
                                                            },
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.seasonDataComparePlayerSelectedRadiosModel,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.seasonDataComparePlayerSelectedRadiosModel =
                                                                $$v
                                                            },
                                                            expression:
                                                              "seasonDataComparePlayerSelectedRadiosModel",
                                                          },
                                                        },
                                                        [
                                                          _c("v-radio", {
                                                            key: index,
                                                            staticClass:
                                                              "px-2 mt-0 py-1",
                                                            attrs: {
                                                              value: `${seasonData.seasonId}-${seasonData.teamId}`,
                                                              color:
                                                                "secondary",
                                                              disabled:
                                                                seasonData.disabled,
                                                            },
                                                            scopedSlots: _vm._u(
                                                              [
                                                                {
                                                                  key: "label",
                                                                  fn: function () {
                                                                    return [
                                                                      _c(
                                                                        "v-card-text",
                                                                        {
                                                                          staticClass:
                                                                            "pa-0 primary--text body-2 font-weight-medium d-flex flex-column align-start justify-center",
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "div",
                                                                            [
                                                                              _c(
                                                                                "object",
                                                                                {
                                                                                  staticClass:
                                                                                    "mr-2",
                                                                                  attrs:
                                                                                    {
                                                                                      data: `https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/leagues/${seasonData.leagueId}.png`,
                                                                                      type: "image/png",
                                                                                      height:
                                                                                        "18",
                                                                                    },
                                                                                },
                                                                                [
                                                                                  _c(
                                                                                    "img",
                                                                                    {
                                                                                      attrs:
                                                                                        {
                                                                                          src: `https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/0.png`,
                                                                                          height:
                                                                                            "15",
                                                                                        },
                                                                                    }
                                                                                  ),
                                                                                ]
                                                                              ),
                                                                              _vm._v(
                                                                                " "
                                                                              ),
                                                                              _c(
                                                                                "span",
                                                                                [
                                                                                  _vm._v(
                                                                                    _vm._s(
                                                                                      seasonData.seasonName
                                                                                    )
                                                                                  ),
                                                                                ]
                                                                              ),
                                                                            ]
                                                                          ),
                                                                          _vm._v(
                                                                            " "
                                                                          ),
                                                                          _c(
                                                                            "span",
                                                                            {
                                                                              staticClass:
                                                                                "body-2 subheader-font",
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                "\n                            " +
                                                                                  _vm._s(
                                                                                    seasonData.teamName
                                                                                  ) +
                                                                                  " \n                            "
                                                                              ),
                                                                              seasonData.minutesPlayed
                                                                                ? _c(
                                                                                    "span",
                                                                                    {
                                                                                      staticClass:
                                                                                        "ms-1",
                                                                                    },
                                                                                    [
                                                                                      _vm._v(
                                                                                        _vm._s(
                                                                                          `(${
                                                                                            seasonData.minutesPlayed
                                                                                          } ${_vm.$t(
                                                                                            "table.history.minutes"
                                                                                          )})`
                                                                                        )
                                                                                      ),
                                                                                    ]
                                                                                  )
                                                                                : _vm._e(),
                                                                            ]
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  },
                                                                  proxy: true,
                                                                },
                                                              ],
                                                              null,
                                                              true
                                                            ),
                                                          }),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  )
                                                : _vm._e()
                                            }
                                          ),
                                        ],
                                        2
                                      )
                                    : _vm._e(),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.stackedView &&
                          _vm.selectedTab !== "polar" &&
                          _vm.shortPositionsPlayedComparePlayer.length > 0 &&
                          _vm.templateActive &&
                          !_vm.templateActive.cPD
                            ? _c(
                                "v-col",
                                {
                                  staticClass: "pt-0 pb-1",
                                  attrs: { cols: "12", sm: "12" },
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "d-flex flex-column" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "mr-5 pt-2 primary--text font-weight-bold body-2",
                                        },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(
                                                _vm.$t(
                                                  "playerRecruitment.positionsPlayed"
                                                )
                                              ) +
                                              "\n                "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "pl-2 d-flex flex-wrap",
                                        },
                                        _vm._l(
                                          _vm.shortPositionsPlayedComparePlayer,
                                          function (shortPosition, index) {
                                            return _c("v-checkbox", {
                                              key: index,
                                              staticClass:
                                                "mr-2 mt-0 py-1 body-2",
                                              attrs: {
                                                value: shortPosition.position,
                                                dense: "",
                                                "hide-details": "",
                                                color: "secondary",
                                              },
                                              on: {
                                                change: function ($event) {
                                                  return _vm.onCompareShortPositionChange(
                                                    shortPosition.position
                                                  )
                                                },
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "label",
                                                    fn: function () {
                                                      return [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "body-1 primary--text font-weight-medium",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                `${_vm.getPositionCode(
                                                                  shortPosition.fieldPositionId
                                                                )} (${
                                                                  shortPosition.minutesPlayed
                                                                } min.)`
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    },
                                                    proxy: true,
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                              model: {
                                                value:
                                                  _vm.shortPositionsPlayedComparePlayerModel,
                                                callback: function ($$v) {
                                                  _vm.shortPositionsPlayedComparePlayerModel =
                                                    $$v
                                                },
                                                expression:
                                                  "shortPositionsPlayedComparePlayerModel",
                                              },
                                            })
                                          }
                                        ),
                                        1
                                      ),
                                    ]
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.stackedView
                            ? _c(
                                "v-col",
                                {
                                  staticClass: "pb-2 px-1",
                                  attrs: { cols: "12" },
                                },
                                [_c("v-divider")],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.selectedTab !== "performance-text"
                            ? _c(
                                "v-col",
                                {
                                  staticClass: "d-flex justify-end py-0 px-2",
                                  attrs: {
                                    cols: "12",
                                    id: "player-download-zone",
                                  },
                                },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass:
                                        "mr-1 ml-0 d-flex align-center elevation-0 monospace-font white--text",
                                      attrs: {
                                        rounded: "",
                                        color: "secondary",
                                        small: "",
                                      },
                                      nativeOn: {
                                        click: function ($event) {
                                          return _vm.saveAsPNG()
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "v-icon",
                                        {
                                          staticClass: "mr-1",
                                          attrs: { small: "" },
                                        },
                                        [
                                          _vm._v(
                                            "\n                  file_download"
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("span", {}, [_vm._v("PNG")]),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass:
                                        "mr-1 ml-0 elevation-0 monospace-font white--text",
                                      attrs: {
                                        rounded: "",
                                        color: "secondary",
                                        small: "",
                                      },
                                      nativeOn: {
                                        click: function ($event) {
                                          return _vm.saveAsSVG()
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "v-icon",
                                        {
                                          staticClass: "mr-1",
                                          attrs: { small: "" },
                                        },
                                        [_vm._v("file_download")]
                                      ),
                                      _vm._v(" "),
                                      _c("span", [_vm._v("SVG")]),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass:
                                        "mr-1 ml-0 elevation-0 monospace-font white--text",
                                      attrs: {
                                        rounded: "",
                                        color: "secondary",
                                        small: "",
                                        loading: _vm.loadingExport,
                                        disabled: _vm.loading,
                                      },
                                      nativeOn: {
                                        click: function ($event) {
                                          return _vm.onGenerateIFrameClick()
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "v-icon",
                                        {
                                          staticClass: "mr-1",
                                          attrs: { small: "" },
                                        },
                                        [_vm._v("share")]
                                      ),
                                      _vm._v(" "),
                                      _c("span", [_vm._v("Embed")]),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          !_vm.loading && !_vm.searchesLimitReached
            ? _c(
                "v-col",
                {
                  ref: "chart",
                  staticClass: "text-center pl-0 pb-0 pt-1",
                  class: {
                    "profile-radar-chart-col--sticky":
                      !_vm.stackedView && _vm.$vuetify.breakpoint.mdAndUp,
                  },
                  attrs: {
                    cols: "12",
                    md: _vm.stackedView ? 12 : 8,
                    order: _vm.stackedView ? 2 : 3,
                    id: "chart",
                  },
                },
                [
                  _c(
                    "v-btn-toggle",
                    {
                      staticClass:
                        "d-flex w-100 align-center justify-center flex-wrap pb-3",
                      attrs: {
                        id: "player-chart-selector",
                        tile: "",
                        color: `${
                          _vm.darkMode ? "lightSecondary" : "secondary"
                        }`,
                        group: "",
                        dense: "",
                        mandatory: "",
                      },
                      on: {
                        change: function ($event) {
                          return _vm.onTabChange($event)
                        },
                      },
                      model: {
                        value: _vm.selectedTab,
                        callback: function ($$v) {
                          _vm.selectedTab = $$v
                        },
                        expression: "selectedTab",
                      },
                    },
                    [
                      _c(
                        "v-btn",
                        { attrs: { value: "radar" } },
                        [
                          _c(
                            "v-icon",
                            {
                              attrs: {
                                small: _vm.$vuetify.breakpoint.smAndDown,
                              },
                            },
                            [_vm._v("wifi_tethering")]
                          ),
                          _vm._v(" "),
                          _vm.$vuetify.breakpoint.lgAndUp
                            ? _c(
                                "span",
                                { staticClass: "body-2 text-lg-button" },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("playerRecruitment.radar"))
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        { attrs: { value: "polar" } },
                        [
                          _c(
                            "v-icon",
                            {
                              attrs: {
                                small: _vm.$vuetify.breakpoint.smAndDown,
                              },
                            },
                            [_vm._v("donut_small")]
                          ),
                          _vm._v(" "),
                          _vm.$vuetify.breakpoint.lgAndUp
                            ? _c(
                                "span",
                                { staticClass: "body-2 text-lg-button" },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("playerRecruitment.polar"))
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        { attrs: { value: "lollipop" } },
                        [
                          _c(
                            "v-icon",
                            {
                              attrs: {
                                small: _vm.$vuetify.breakpoint.smAndDown,
                              },
                            },
                            [_vm._v("stacked_bar_chart")]
                          ),
                          _vm._v(" "),
                          _vm.$vuetify.breakpoint.lgAndUp
                            ? _c("span", { staticClass: "body-2" }, [
                                _vm._v(
                                  _vm._s(_vm.$t("playerRecruitment.lollipop"))
                                ),
                              ])
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        { attrs: { value: "performance-text" } },
                        [
                          _c(
                            "v-icon",
                            {
                              attrs: {
                                small: _vm.$vuetify.breakpoint.smAndDown,
                              },
                            },
                            [_vm._v("reorder")]
                          ),
                          _vm._v(" "),
                          _vm.$vuetify.breakpoint.lgAndUp
                            ? _c(
                                "span",
                                { staticClass: "body-2 text-lg-button" },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("playerRecruitment.text"))
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.radarData &&
                  _vm.radarData.minutesPlayed < 450 &&
                  _vm.size != 0 &&
                  (_vm.radarData ||
                    _vm.mainPlayerRadarData ||
                    _vm.comparePlayerRadarData) &&
                  _vm.shortPositionsPlayed &&
                  _vm.shortPositionsPlayed.length
                    ? _c(
                        "v-alert",
                        {
                          staticClass:
                            "mt-2 mx-5 mb-0 py-1 body-1 font-weight-medium",
                          attrs: { dense: "", type: "warning", border: "left" },
                        },
                        [
                          _vm._v(
                            "\n        " +
                              _vm._s(_vm.$t("playerDetail.warningMinutes")) +
                              "\n        "
                          ),
                          _c("br"),
                          _vm._v(" "),
                          _vm.minMaxModel !== "top5Leagues" &&
                          !_vm.seasonSelectedHasAverage
                            ? _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("playerDetail.warningSeasonGames")
                                  )
                                ),
                              ])
                            : _vm._e(),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.radarData.statsRemoved
                    ? _c(
                        "v-alert",
                        {
                          staticClass:
                            "mt-2 mx-5 mb-0 py-1 body-1 font-weight-medium",
                          attrs: { dense: "", type: "warning", border: "left" },
                        },
                        [
                          _vm._v(
                            "\n        " +
                              _vm._s(
                                _vm.$t("playerDetail.warningStatsRemoved")
                              ) +
                              "\n      "
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.player &&
                  _vm.avatarSize &&
                  _vm.mediaMode &&
                  _vm.selectedTab !== "performance-text"
                    ? _c("PlayerAvatarMedia", {
                        key: _vm.playerAvatarMediaKey,
                        ref: "playerAvatarMediaRef",
                        staticClass: "mt-2",
                        attrs: {
                          player: _vm.player,
                          width: _vm.size,
                          height: _vm.avatarSize.height,
                          id: `${_vm.player.playerId}-${this.radarId}`,
                          margin: _vm.margin,
                          title: _vm.mediaModeData.upperText,
                          subtitle: _vm.mediaModeData.lowerText,
                          color: _vm.mediaModeData.borderColor,
                          bgColor: _vm.mediaModeData.bgColor,
                          textColor: _vm.mediaModeData.textColor,
                          comparisonPlayerData: _vm.comparePlayerData,
                          comparisonTitle:
                            _vm.mediaModeData.comparisonUpperText,
                          comparisonSubtitle:
                            _vm.mediaModeData.comparisonLowerText,
                          comparisonColor:
                            _vm.mediaModeData.comparisonBorderColor,
                          type: _vm.selectedTab,
                          face: _vm.mediaModeData.face.dataUrl,
                          comparisonFace:
                            _vm.mediaModeData.comparisonFace.dataUrl,
                          nationalTeam: _vm.mediaModeData.nationalTeam,
                          lineDistance: _vm.mediaModeData.lineLength,
                          lineWeight: _vm.mediaModeData.lineWeight,
                          avatarSize: _vm.mediaModeData.avatarSize,
                          upperTextFontSize:
                            _vm.mediaModeData.upperTextFontSize,
                          upperTextFontWeight:
                            _vm.mediaModeData.upperTextFontWeight,
                          lowerTextFontSize:
                            _vm.mediaModeData.lowerTextFontSize,
                          lowerTextFontWeight:
                            _vm.mediaModeData.lowerTextFontWeight,
                          fontFamily: _vm.mediaModeData.fontFamily,
                          team: _vm.team,
                          comparisonLeague: _vm.leaguesAverageObjectModel,
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.player &&
                  _vm.size != 0 &&
                  _vm.radarData != null &&
                  _vm.selectedTab === "radar" &&
                  !_vm.loading
                    ? _c("RadarChart", {
                        key: _vm.chartKey,
                        ref: "radarRef",
                        class: { "mt-2": !_vm.mediaMode },
                        attrs: {
                          id: `${_vm.player.playerId}-${this.radarId}`,
                          size: _vm.size,
                          margin: _vm.margin,
                          radarData: _vm.radarData,
                          darkMode: _vm.darkMode,
                          dataPer90MinText: _vm.dataPer90MinText,
                          adjustToPossessionText: _vm.adjustToPossessionText,
                          playerName: _vm.player.name,
                          radarTitle: _vm.radarTitle,
                          yob: _vm.yob,
                          comparePlayerData: _vm.comparePlayerData,
                          mediaMode: _vm.mediaMode,
                          colors: _vm.radarColors,
                          bgColor: _vm.mediaModeData.bgColor,
                          textColor: _vm.mediaModeData.textColor,
                          axisColor: _vm.mediaModeData.axisColor,
                          logoCfg: _vm.mediaModeData.logo,
                          fontFamily: _vm.mediaModeData.fontFamily,
                          showRadarIcons: _vm.showRadarIcons,
                        },
                        on: {
                          sizeChange: function ($event) {
                            return _vm.onRadarSizeChange($event)
                          },
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.loading &&
                  _vm.showRadarIcons &&
                  _vm.selectedTab === "radar"
                    ? _c(
                        "div",
                        {
                          staticClass: "py-5 d-flex justify-center",
                          attrs: { cols: "12" },
                        },
                        [
                          _c(
                            "p",
                            {
                              staticClass:
                                "my-0 me-5 subheader-font body-2 monospace-font",
                            },
                            [
                              _c(
                                "v-icon",
                                {
                                  staticClass: "me-1",
                                  staticStyle: { "font-size": "16px" },
                                  attrs: { small: "" },
                                },
                                [_vm._v("tune")]
                              ),
                              _vm._v(
                                _vm._s(_vm.$t("roles.ROLE_EVENTING_DATA"))
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "p",
                            {
                              staticClass:
                                "my-0 me-5 subheader-font body-2 monospace-font",
                            },
                            [
                              _c(
                                "v-icon",
                                {
                                  staticClass: "me-1",
                                  staticStyle: { "font-size": "16px" },
                                  attrs: { small: "" },
                                },
                                [_vm._v("speed")]
                              ),
                              _vm._v(
                                _vm._s(_vm.$t("roles.ROLE_PHYSICAL_DATA"))
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "p",
                            {
                              staticClass:
                                "my-0 me-5 subheader-font body-2 monospace-font",
                            },
                            [
                              _c(
                                "v-icon",
                                {
                                  staticClass: "me-1",
                                  staticStyle: { "font-size": "12px" },
                                  attrs: { small: "" },
                                },
                                [_vm._v("fa-wand-magic-sparkles")]
                              ),
                              _vm._v(_vm._s(_vm.$t("roles.ROLE_ARRIGO"))),
                            ],
                            1
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.lollipopData &&
                  !_vm.lollipopData.statDTOs[1] &&
                  _vm.size != 0 &&
                  _vm.selectedTab === "lollipop" &&
                  !_vm.loading
                    ? _c("LollipopChart", {
                        key: _vm.chartKey,
                        ref: "lollipopRef",
                        attrs: {
                          id: `${_vm.player.playerId}-${this.radarId}`,
                          size: _vm.size,
                          chartData: _vm.lollipopData,
                          dataPer90MinText: _vm.dataPer90MinText,
                          adjustToPossessionText: _vm.adjustToPossessionText,
                          playerName: _vm.player.name,
                          radarTitle: _vm.radarTitle,
                          yob: _vm.yob,
                          minMaxLabel: _vm.lollipopMinMaxLabel,
                          mediaMode: _vm.mediaMode,
                          colors: _vm.radarColors,
                          bgColor: _vm.mediaMode
                            ? _vm.mediaModeData.bgColor
                            : _vm.defaultColors.bgColor,
                          textColor: _vm.mediaModeData.textColor,
                          axisColor: _vm.mediaModeData.axisColor,
                          logoCfg: _vm.mediaModeData.logo,
                          fontFamily: _vm.mediaModeData.fontFamily,
                        },
                        on: {
                          sizeChange: function ($event) {
                            return _vm.onRadarSizeChange($event)
                          },
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.lollipopData &&
                  _vm.lollipopData.statDTOs[1] &&
                  _vm.size != 0 &&
                  _vm.selectedTab === "lollipop" &&
                  !_vm.loading
                    ? _c("CompareLollipopChart", {
                        key: _vm.chartKey,
                        ref: "compareLollipopRef",
                        attrs: {
                          id: `${_vm.player.playerId}-${this.radarId}`,
                          size: _vm.size,
                          chartData: _vm.lollipopData,
                          dataPer90MinText: _vm.dataPer90MinText,
                          adjustToPossessionText: _vm.adjustToPossessionText,
                          playerName: _vm.player.name,
                          radarTitle: _vm.radarTitle,
                          yob: _vm.yob,
                          minMaxLabel: _vm.lollipopMinMaxLabel,
                          comparePlayerData: _vm.comparePlayerData,
                          mediaMode: _vm.mediaMode,
                          colors: _vm.radarColors,
                          bgColor: _vm.mediaMode
                            ? _vm.mediaModeData.bgColor
                            : _vm.defaultColors.bgColor,
                          textColor: _vm.mediaModeData.textColor,
                          axisColor: _vm.mediaModeData.axisColor,
                          fontFamily: _vm.mediaModeData.fontFamily,
                          logoCfg: _vm.mediaModeData.logo,
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.playerProfiles && _vm.templateActivePosition
                    ? _c("RadarDescription", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              _vm.selectedTab === "performance-text" &&
                              _vm.mainPlayerRadarData != null &&
                              _vm.seasonIdsMainPlayerSelected,
                            expression:
                              "selectedTab === 'performance-text' && mainPlayerRadarData != null && seasonIdsMainPlayerSelected",
                          },
                        ],
                        attrs: {
                          radarData: _vm.mainPlayerRadarData,
                          seasonMoreMinutesPlayedYear:
                            _vm.seasonMoreMinutesPlayedYear,
                          leagueIdWithMoreMinutesPlayed:
                            _vm.leagueIdWithMoreMinutesPlayed,
                          leagueLabelWithMoreMinutesPlayed:
                            _vm.leagueLabelWithMoreMinutesPlayed
                              ? _vm.leagueLabelWithMoreMinutesPlayed.toString()
                              : _vm.leagueLabelWithMoreMinutesPlayed,
                          seasonIds: _vm.seasonIdsMainPlayerSelected,
                          player: _vm.player,
                          playerProfiles: _vm.playerProfiles,
                          radarTemplate: _vm.templateActivePosition,
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.comparePlayerProfiles && _vm.templateActivePosition
                    ? _c("RadarDescription", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              _vm.selectedTab === "performance-text" &&
                              _vm.comparePlayerRadarData != null &&
                              _vm.seasonIdsComparePlayerSelected,
                            expression:
                              "selectedTab === 'performance-text' && comparePlayerRadarData != null && seasonIdsComparePlayerSelected",
                          },
                        ],
                        attrs: {
                          radarData: _vm.comparePlayerRadarData,
                          seasonMoreMinutesPlayedYear:
                            _vm.seasonMoreMinutesPlayedComparePlayerYear,
                          leagueIdWithMoreMinutesPlayed:
                            _vm.leagueIdWithMoreMinutesPlayedComparePlayer,
                          leagueLabelWithMoreMinutesPlayed:
                            _vm.leagueLabelWithMoreMinutesPlayedComparePlayer
                              ? _vm.leagueLabelWithMoreMinutesPlayedComparePlayer.toString()
                              : _vm.leagueLabelWithMoreMinutesPlayedComparePlayer,
                          seasonIds: _vm.seasonIdsComparePlayerSelected,
                          player: _vm.selectedPlayer,
                          playerProfiles: _vm.comparePlayerProfiles,
                          radarTemplate: _vm.templateActivePosition,
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.player &&
                  _vm.size != 0 &&
                  _vm.polarData != null &&
                  _vm.selectedTab === "polar"
                    ? _c("PolarChart", {
                        key: _vm.chartKey,
                        class: { "mt-2": !_vm.mediaMode },
                        attrs: {
                          id: `${_vm.player.playerId}-${this.radarId}`,
                          size: _vm.size,
                          margin: _vm.margin,
                          polarData: _vm.polarData,
                          darkMode: _vm.darkMode,
                          dataPer90MinText: _vm.dataPer90MinText,
                          adjustToPossessionText: _vm.adjustToPossessionText,
                          playerName: _vm.player.name,
                          polarTitle: _vm.radarTitle,
                          yob: _vm.yob,
                          mediaMode: _vm.mediaMode,
                          colors: _vm.radarColors,
                          bgColor: _vm.mediaMode
                            ? _vm.mediaModeData.bgColor
                            : _vm.defaultColors.bgColor,
                          textColor: _vm.mediaModeData.textColor,
                          axisColor: _vm.mediaModeData.axisColor,
                          logoCfg: _vm.mediaModeData.logo,
                          fontFamily: _vm.mediaModeData.fontFamily,
                        },
                        on: {
                          sizeChange: function ($event) {
                            return _vm.onRadarSizeChange($event)
                          },
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.player &&
                  _vm.size &&
                  _vm.mediaMode &&
                  _vm.mediaModeData.socialMedia &&
                  _vm.selectedTab !== "performance-text"
                    ? _c("DriblabSocialMedia", {
                        key: _vm.socialMediaKey,
                        ref: "driblabSocialMediaRef",
                        attrs: {
                          width: _vm.size,
                          height: 50,
                          id: `${_vm.player.playerId}-${this.radarId}`,
                          margin: _vm.margin,
                          bgColor: _vm.mediaModeData.bgColor,
                          textColor: _vm.mediaModeData.textColor,
                          fontSize: _vm.mediaModeData.socialMediaFontSize,
                          fontWeight: _vm.mediaModeData.socialMediaFontWeight,
                          logoCfg: _vm.mediaModeData.logo,
                          sponsor: _vm.mediaModeData.sponsor.dataUrl,
                          fontFamily: _vm.mediaModeData.fontFamily,
                          type: _vm.selectedTab,
                        },
                      })
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.loading
            ? _c(
                "v-col",
                {
                  ref: "chart",
                  staticClass:
                    "text-center pb-0 pt-4 d-flex align-center flex-column",
                  class: {
                    "profile-radar-chart-col--sticky":
                      !_vm.stackedView && _vm.$vuetify.breakpoint.mdAndUp,
                  },
                  attrs: {
                    cols: "12",
                    md: _vm.stackedView ? 12 : 8,
                    order: _vm.stackedView ? 2 : 3,
                    id: "chart",
                  },
                },
                [
                  _c(
                    "span",
                    { staticClass: "mb-3 primary--text monospace-font" },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("loadingMessages.placeholder")) + "..."
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("v-skeleton-loader", {
                    staticClass: "big-avatar-skeleton",
                    attrs: { type: "avatar" },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.loading && _vm.searchesLimitReached
            ? _c(
                "v-col",
                {
                  staticClass: "py-0",
                  class: {
                    "profile-radar-chart-col--sticky":
                      !_vm.stackedView && _vm.$vuetify.breakpoint.mdAndUp,
                  },
                  attrs: {
                    cols: "12",
                    md: _vm.stackedView ? 12 : 7,
                    order: _vm.stackedView ? 2 : 3,
                  },
                },
                [
                  _c(
                    "v-col",
                    {
                      staticClass:
                        "d-flex flex-column justify-center align-center",
                      attrs: { cols: "12" },
                    },
                    [
                      _c(
                        "v-icon",
                        {
                          staticStyle: { "font-size": "15rem" },
                          attrs: { color: "primary lighten-5" },
                        },
                        [_vm._v("lock")]
                      ),
                      _vm._v(" "),
                      _c("span", { staticClass: "text-h4 primary--text" }, [
                        _vm._v(
                          "You have reached the limit of searches per day for the demo period."
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "span",
                        { staticClass: "text-h5 subheader-font mt-2" },
                        [
                          _vm._v(
                            "Contact the Driblab team to obtain unlimited searches. Your account will be reopened tomorrow."
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          staticClass:
                            "elevation-0 monospace-font white--text px-5 mt-5",
                          attrs: {
                            to: "/home",
                            color: "secondary",
                            rounded: "",
                          },
                        },
                        [_vm._v("GO HOME")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c("RadarTemplateFormModal", {
        ref: "formModalRef",
        attrs: {
          title: _vm.$t("settings.radarTemplates"),
          subtitle: _vm.$t("settings.radarTemplatesSubtitle"),
          positionId: _vm.player.positionId,
        },
        on: {
          save: function ($event) {
            return _vm.getRadarTemplates()
          },
        },
      }),
      _vm._v(" "),
      _c("ChartExportLinksModal", {
        ref: "chartExportLinksModalRef",
        attrs: {
          title: _vm.player.name,
          subtitle:
            this.selectedTab === "radar" || this.selectedTab === "polar"
              ? _vm.$t("playerRecruitment.radar")
              : _vm.$t("playerRecruitment.lollipop"),
        },
      }),
      _vm._v(" "),
      _vm.currentUser.showTour
        ? _c("Tour", {
            attrs: { name: "playerRadarTour", steps: _vm.tourSteps },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }